/*
  fb-personaliser.js — the templated mug personaliser engine.
  Extracted from snippets/flipping-bangers-personaliser.liquid so the
  Liquid template stays under Shopify's 256 KB per-file limit and the
  browser can cache the engine. Contains NO Liquid — it reads all config
  from the <script type="application/json" data-fb-config> block that the
  snippet renders. Loaded via <script src> at the same point in the markup
  the inline script used to sit, so execution timing is unchanged.
*/
  (function () {
    // Build marker — bumped on every theme push so you can confirm
    // in DevTools Console that the latest build is actually live (vs.
    // a cached old version). Look for "[fb-personaliser] build …"
    // immediately after page load. Format: YYYY-MM-DD-rN.
    console.log('[fb-personaliser] build 2026-06-28-r25 — swap keeps old design until new decodes (no blank flash)');

    var root = document.querySelector('[data-fb-personaliser]');
    if (!root) return;

    // ---- Read template config ----
    var configEl = root.querySelector('[data-fb-config]');
    var TPL;
    try { TPL = JSON.parse(configEl.textContent); }
    catch (e) {
      console.error('[fb-personaliser] invalid template config', e);
      return;
    }

    // ---- Mode flag ----
    // Multi-field templates (e.g. Vintage 70's Edition with Title +
    // Name + Supporting Line) have any field with `anchor_y` defined.
    // Legacy single-text templates (numberplates) take the unchanged
    // path through the rest of this script.
    var IS_MF = !!TPL.is_multifield;

    // ---- DOM refs (single-text mode) ----
    var input          = root.querySelector('[data-fb-input]');
    var charCountEl    = root.querySelector('[data-fb-charcount]');
    var sizeInput      = root.querySelector('[data-fb-size]');
    var thicknessInput = root.querySelector('[data-fb-thickness]');
    var thicknessSlider= root.querySelector('[data-fb-thickness-slider]');
    var thicknessValEl = root.querySelector('[data-fb-thickness-val]');
    var flatPreview    = root.querySelector('[data-fb-flat-preview]');
    var flatCtx        = flatPreview ? flatPreview.getContext('2d') : null;

    // ---- DOM refs (multi-field mode) ----
    var mfInputs = IS_MF ? root.querySelectorAll('[data-mf-input]') : [];
    var mfTokens = IS_MF ? root.querySelectorAll('[data-mf-token]') : [];

    // Customer-controlled thickness (0–50). Initial value comes from the
    // hidden line-item-property input (default 0); slider drives it live.
    var THICKNESS = parseFloat((thicknessInput && thicknessInput.value) || 0);

    // No usable input set = nothing to do for this template.
    // Single-text templates need [data-fb-input].
    // Multi-field templates need at least one [data-mf-input] OR at
    // least one image field (image-only templates are valid — the
    // image fields render their own upload UI further down).
    if (!IS_MF && !input) {
      return;
    }
    var IMAGE_FIELDS_PROBE = (TPL.fields || []).filter(function (f) { return f.type === 'image'; });
    if (IS_MF && mfInputs.length === 0 && IMAGE_FIELDS_PROBE.length === 0) {
      console.warn('[fb-personaliser] multi-field template has no inputs');
      return;
    }

    // ---- Single-text constants from schema (only used when !IS_MF) ----
    var PT             = TPL.primary_text || {};
    var MAX            = PT.max_chars     || 10;
    var SIZE_CAPS      = PT.size_caps     || {};
    var SIZE_FALLBACK  = PT.size_fallback || 70;
    var TEXT_COLOR     = PT.color         || '#111111';
    // Weathering intensity 0..1 — 0 = clean text (e.g. yellow numberplate),
    // up to 1 = heavily eroded (e.g. vintage rusty plate).
    // Live-tunable via the calibration panel; baked into the metaobject's
    // content_schema for the production value.
    var WEATHERING     = PT.weathering    || 0;

    // Font mapping — schema says e.g. "charles-wright" or "black-ops-one";
    // we map to a CSS font-family stack with appropriate fallbacks.
    // Lilita One + Source Serif 4 are added for multi-field templates
    // (seventies edition); Liquid loads the corresponding Google Fonts
    // <link> at page top whenever a field references them.
    var FONT_STACKS = {
      'charles-wright':   '"Charles Wright", "Helvetica Neue Bold", "Arial Black", sans-serif',
      'black-ops-one':    '"Black Ops One", "Stencil Std", "Stencil", Impact, sans-serif',
      'lilita-one':       '"Lilita One", "Cooper Black", "Cooper Std", Georgia, serif',
      'source-serif':     '"Source Serif 4", "Source Serif Pro", Georgia, "Times New Roman", serif',
      // Display fonts added May 2026 for the Daddy's Team font picker.
      // Fallbacks chosen to roughly preserve the on-screen feel before
      // the Google Font finishes loading (avoids a jarring FOIT/FOUT).
      'bebas-neue':       '"Bebas Neue", "Oswald", "Impact", "Haettenschweiler", "Franklin Gothic Bold", sans-serif',
      'anton':            '"Anton", "Oswald", "Impact", "Haettenschweiler", "Franklin Gothic Bold", sans-serif',
      'permanent-marker': '"Permanent Marker", "Marker Felt", "Comic Sans MS", "Bradley Hand", cursive',
      'russo-one':        '"Russo One", "Eurostile", "Impact", "Franklin Gothic Bold", sans-serif',
      'amatic-sc':        '"Amatic SC", "Comic Sans MS", "Bradley Hand", cursive',
      'gochi-hand':       '"Gochi Hand", "Comic Sans MS", "Bradley Hand", cursive',
    };
    var FONT_FAMILY    = FONT_STACKS[PT.font] || FONT_STACKS['charles-wright'];

    function maxSizeFor(len) { return SIZE_CAPS[len] || SIZE_FALLBACK; }

    // ============================================================
    // Uploadcare integration — image fields
    // ============================================================
    //
    // We render our own per-field "Choose image" / "Change image"
    // buttons (in Liquid above) and drive a single shared Uploadcare
    // file-uploader instance via its ctx-provider API. This mirrors
    // the integration in snippets/flipping-bangers-free-form.liquid.
    //
    // Flow:
    //   1. Customer clicks a field's button — we set activeFieldName
    //      to that field's property_name and call initFlow() on the
    //      ctx provider to open Uploadcare's modal.
    //   2. Customer picks / uploads an image → Uploadcare dispatches
    //      `file-upload-success` on the ctx provider with the new
    //      file's cdnUrl + uuid in event.detail.
    //   3. Our handler routes the URL to the active field: writes
    //      properties[<Name>] (visible to cart) + properties[_<Name> url]
    //      (hidden, used by the print recreator), shows the thumbnail,
    //      flips the button label to "Change image", then calls
    //      loadPhoto() to drive the live preview / drag / low-res warning.
    //
    // No MutationObserver, no Vue, no relocation gymnastics — Uploadcare's
    // file-uploader is a self-contained web component.
    var IMAGE_FIELDS = (TPL.fields || []).filter(function (f) { return f.type === 'image'; });
    var HAS_IMAGE_FIELDS = IMAGE_FIELDS.length > 0;

    // property_name (e.g. "Photo 1") → loaded HTMLImageElement (or undefined)
    var photoImages = {};
    // property_name → URL string (used to detect changes and avoid reload churn)
    var photoUrls   = {};
    // property_name → Uploadcare UUID — used to re-load this field's own
    // file into Uploadcare's modal when the customer reopens it. Without
    // tracking this per field, Uploadcare's shared collection accumulates
    // every uploaded file across all 5 photos and the modal opens showing
    // whichever file was most recently dropped in (typically Photo 1's),
    // not the field the customer actually clicked on.
    var photoUuids  = {};
    // property_name → { x, y } each in [-1, 1] — customer's drag offset
    // applied to the source-image crop window. 0,0 = centred (default).
    // Submitted with the order as `properties[_<Property> offset]` so
    // the print recreator applies the same offset to the print PNG.
    var photoOffsets = {};

    // Routing state — set by the per-field button click handler just
    // before opening the Uploadcare modal. Read by handleUploadcareSuccess
    // when the modal finishes so we know which field the new file belongs to.
    var activeFieldName = null;

    // Build a preview URL from a bare Uploadcare CDN URL. Caps the
    // request size so the live preview canvas stays snappy and the
    // low-res warning sees actual photo pixels (not an upscaled
    // version of a tiny thumbnail).
    function buildPreviewUrl(cdnUrl) {
      if (!cdnUrl) return '';
      var base = cdnUrl;
      if (!/\/$/.test(base)) base += '/';
      return base + '-/preview/1500x1500/';
    }

    function handleUploadcareSuccess(event) {
      var detail = event.detail || {};
      // v1 event detail shape: { uuid, cdnUrl, name, size, ... }
      // Some events (change) carry `allEntries` array instead.
      var entries = detail.allEntries || (detail.cdnUrl ? [detail] : []);
      if (!entries.length && detail.fileInfo && detail.fileInfo.cdnUrl) {
        entries = [detail.fileInfo];
      }
      var entry = entries[0];
      if (!entry || !entry.cdnUrl) return;

      // Without an active field name we have nothing to route to.
      // (Defensive — should never happen because we only open the
      // modal from a field button click which sets it.)
      var name = activeFieldName;
      if (!name) {
        console.warn('[fb-personaliser] upload-success but no active field');
        return;
      }

      var bareUrl    = entry.cdnUrl;
      var previewUrl = buildPreviewUrl(bareUrl);

      // Track the UUID per field so re-opening the modal pre-loads
      // THIS field's existing file (not whichever was last uploaded
      // anywhere). The bareUrl looks like https://ucarecdn.com/{UUID}/
      // — entry.uuid is the canonical source.
      if (entry.uuid) photoUuids[name] = entry.uuid;

      writeFieldUrl(name, bareUrl, previewUrl);
    }

    // Idempotent: writing the same URL again is a no-op past the
    // initial property-input update. Safe to call from any code path.
    function writeFieldUrl(name, bareUrl, previewUrl) {
      // 1. properties[<Name>] — the visible cart property. Mirrors
      //    what UploadKit used to write (bare CDN URL).
      var cartInput = root.querySelector(
        '[data-mf-image-cart-url][data-mf-property-name="' + name + '"]'
      );
      if (cartInput && cartInput.value !== bareUrl) cartInput.value = bareUrl;

      // 2. properties[_<Name> url] — hidden, full-res URL for the
      //    print recreator. Same as the bare URL today; the
      //    underscore prefix hides it from the customer in cart/emails.
      var urlInput = root.querySelector(
        '[data-mf-image-url][data-mf-property-name="' + name + '"]'
      );
      if (urlInput && urlInput.value !== bareUrl) urlInput.value = bareUrl;

      // 3. Update the visible thumbnail + button label.
      var thumb = root.querySelector(
        '[data-mf-image-thumb][data-mf-property-name="' + name + '"]'
      );
      if (thumb) {
        // Preview at 800x800 — the thumbnail's now full-cell-width
        // (grid mode), so 120x120 looked grossly upscaled. 800 covers
        // even a wide grid cell on a high-DPI screen, format=auto
        // serves WebP/AVIF where supported, quality=smart trims bytes.
        thumb.style.backgroundImage = 'url("' + bareUrl + '-/preview/800x800/-/format/auto/-/quality/smart/")';
        thumb.hidden = false;
      }
      var btn = root.querySelector(
        '[data-mf-image-btn][data-mf-property-name="' + name + '"]'
      );
      if (btn) btn.textContent = 'Edit image';
      var rmBtn = root.querySelector(
        '[data-mf-image-remove][data-mf-property-name="' + name + '"]'
      );
      if (rmBtn) rmBtn.hidden = false;

      // 4. Reset the drag offset (new image isn't framed the same way),
      //    clear any stale low-res warning, and kick off the photo load.
      if (previewUrl !== photoUrls[name]) {
        photoUrls[name] = previewUrl;
        photoOffsets[name] = { x: 0, y: 0 };
        writeOffsetProperty(name);
        clearLowResWarning(name);
        loadPhoto(name, previewUrl);
      }

      // 5. Re-evaluate the upload gate — a new photo may have just
      //    completed the set, in which case the ATC button unlocks.
      updateAtcGate();

      // 6. Persist to localStorage so a page refresh keeps the work.
      saveDraftState();
    }

    // ============================================================
    // localStorage autosave — image-field templates only
    // ============================================================
    //
    // Mirrors the free-form editor's autosave pattern. Each upload
    // (and drag-to-reposition) writes the current state to
    // localStorage keyed by product handle. On page load, restoreDraft
    // re-applies any saved state so the customer doesn't lose their
    // work to an accidental refresh / tab switch / variant change.
    //
    // What we save per field:
    //   - url: bare CDN URL (the canonical reference)
    //   - uuid: Uploadcare UUID (used to re-load into the modal for
    //     re-edit)
    //   - offset: the customer's drag-to-reposition offset
    //
    // Keyed per-product so a half-built Daddy mug doesn't clobber a
    // half-built BDE mug.
    var DRAFT_STORAGE_KEY = HAS_IMAGE_FIELDS && TPL.product_handle
      ? 'fb-personaliser:' + TPL.product_handle
      : null;

    function saveDraftState() {
      if (!DRAFT_STORAGE_KEY) return;
      var state = {};
      var anySaved = false;
      IMAGE_FIELDS.forEach(function (f) {
        var name = f.property_name;
        var cartInput = root.querySelector(
          '[data-mf-image-cart-url][data-mf-property-name="' + name + '"]'
        );
        if (cartInput && cartInput.value) {
          state[name] = {
            url:    cartInput.value,
            uuid:   photoUuids[name] || null,
            offset: photoOffsets[name] || { x: 0, y: 0 },
          };
          anySaved = true;
        }
      });
      try {
        if (anySaved) {
          localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(state));
        } else {
          // No fields filled — drop the entry entirely.
          localStorage.removeItem(DRAFT_STORAGE_KEY);
        }
      } catch (e) {
        // Storage full / disabled (private mode) — fail silently.
      }
    }

    function restoreDraftState() {
      if (!DRAFT_STORAGE_KEY) return;
      var raw;
      try { raw = localStorage.getItem(DRAFT_STORAGE_KEY); }
      catch (e) { return; }
      if (!raw) return;
      var state;
      try { state = JSON.parse(raw); }
      catch (e) { return; }
      if (!state || typeof state !== 'object') return;

      IMAGE_FIELDS.forEach(function (f) {
        var name = f.property_name;
        var saved = state[name];
        if (!saved || !saved.url) return;

        // Re-seed UUID first so the next "Change / Edit Image" click
        // pre-loads the existing file into the Uploadcare modal.
        if (saved.uuid) photoUuids[name] = saved.uuid;

        // writeFieldUrl handles the inputs/thumbnail/button/preview.
        // It will reset the offset to 0,0 because the URL is "new" to
        // its photoUrls cache, so we re-apply the saved offset right
        // after and re-render to pick it up.
        writeFieldUrl(name, saved.url, buildPreviewUrl(saved.url));
        if (saved.offset && (saved.offset.x !== 0 || saved.offset.y !== 0)) {
          photoOffsets[name] = { x: saved.offset.x, y: saved.offset.y };
          writeOffsetProperty(name);
        }
      });

      // Final render pass — picks up restored offsets on the flat
      // preview + cylinder views (once three.js is ready).
      if (typeof renderTextureMain === 'function') renderTextureMain();
      if (typeof renderAll === 'function') renderAll();
    }

    // Persist drag-to-reposition adjustments too, not just uploads.
    // Wraps writeOffsetProperty so every offset write also triggers
    // a localStorage save.
    var origWriteOffsetProperty = writeOffsetProperty;
    writeOffsetProperty = function (name) {
      origWriteOffsetProperty(name);
      saveDraftState();
    };

    // ============================================================
    // Start-over button
    // ============================================================
    //
    // Wipes all uploaded photos + offsets + the saved localStorage
    // draft. Visible only when at least one photo has been uploaded
    // (toggled by updateClearButtonVisibility, called from the gate).
    function clearAllPhotos() {
      if (!HAS_IMAGE_FIELDS) return;
      // Destructive — confirm with the customer first.
      var ok = window.confirm(
        'Remove all uploaded photos and start over? This can’t be undone.'
      );
      if (!ok) return;

      IMAGE_FIELDS.forEach(function (f) {
        var name = f.property_name;

        // Clear hidden inputs.
        var cartInput = root.querySelector(
          '[data-mf-image-cart-url][data-mf-property-name="' + name + '"]'
        );
        if (cartInput) cartInput.value = '';
        var urlInput = root.querySelector(
          '[data-mf-image-url][data-mf-property-name="' + name + '"]'
        );
        if (urlInput) urlInput.value = '';
        var offsetInput = root.querySelector(
          '[data-mf-image-offset][data-mf-property-name="' + name + '"]'
        );
        if (offsetInput) offsetInput.value = '0,0';

        // Reset thumbnail.
        var thumb = root.querySelector(
          '[data-mf-image-thumb][data-mf-property-name="' + name + '"]'
        );
        if (thumb) {
          thumb.style.backgroundImage = '';
          thumb.hidden = true;
        }

        // Reset button label.
        var btn = root.querySelector(
          '[data-mf-image-btn][data-mf-property-name="' + name + '"]'
        );
        if (btn) btn.textContent = 'Choose image';

        // Hide the per-photo Remove link (no photo left to remove).
        var rmBtn = root.querySelector(
          '[data-mf-image-remove][data-mf-property-name="' + name + '"]'
        );
        if (rmBtn) rmBtn.hidden = true;

        // Clear JS state.
        delete photoImages[name];
        delete photoUrls[name];
        delete photoUuids[name];
        photoOffsets[name] = { x: 0, y: 0 };
        // Sync the hole overlay — × badge → + button.
        if (typeof updateHoleOverlayState === 'function') {
          updateHoleOverlayState(name);
        }

        // Clear low-res warning.
        clearLowResWarning(name);
      });

      // Clear localStorage so a refresh stays empty.
      if (DRAFT_STORAGE_KEY) {
        try { localStorage.removeItem(DRAFT_STORAGE_KEY); } catch (e) {}
      }

      // Re-render the plate (now blank polaroids) + update gallery state.
      if (typeof redrawAfterPhotoChange === 'function') {
        redrawAfterPhotoChange();
      }

      // Re-evaluate the gate — ATC will re-disable, gate note re-appears.
      updateAtcGate();
    }

    // Toggle the start-over button's visibility based on whether
    // anything's actually uploaded. Called from updateAtcGate after
    // every state change, so it stays in sync automatically.
    function updateClearButtonVisibility() {
      if (!HAS_IMAGE_FIELDS) return;
      var anyUploaded = false;
      for (var i = 0; i < IMAGE_FIELDS.length; i++) {
        var name = IMAGE_FIELDS[i].property_name;
        var inp = root.querySelector(
          '[data-mf-image-cart-url][data-mf-property-name="' + name + '"]'
        );
        if (inp && inp.value) { anyUploaded = true; break; }
      }
      var row = root.querySelector('[data-fb-clear-row]');
      if (row) row.hidden = !anyUploaded;
    }

    // Wire up the clear button click.
    var clearBtn = root.querySelector('[data-fb-clear-photos]');
    if (clearBtn) {
      clearBtn.addEventListener('click', clearAllPhotos);
    }

    // ============================================================
    // Per-photo remove
    // ============================================================
    //
    // Wipes a single field's uploaded photo + drag offset + UUID,
    // resets its inputs/thumbnail/button, persists the change to
    // localStorage, and re-evaluates the gate. Used by the small
    // "✕ Remove" link rendered next to each Change button.
    function removeFieldPhoto(name) {
      // Clear hidden inputs.
      var cartInput = root.querySelector(
        '[data-mf-image-cart-url][data-mf-property-name="' + name + '"]'
      );
      if (cartInput) cartInput.value = '';
      var urlInput = root.querySelector(
        '[data-mf-image-url][data-mf-property-name="' + name + '"]'
      );
      if (urlInput) urlInput.value = '';
      var offsetInput = root.querySelector(
        '[data-mf-image-offset][data-mf-property-name="' + name + '"]'
      );
      if (offsetInput) offsetInput.value = '0,0';

      // Reset thumbnail + button label.
      var thumb = root.querySelector(
        '[data-mf-image-thumb][data-mf-property-name="' + name + '"]'
      );
      if (thumb) {
        thumb.style.backgroundImage = '';
        thumb.hidden = true;
      }
      var btn = root.querySelector(
        '[data-mf-image-btn][data-mf-property-name="' + name + '"]'
      );
      if (btn) btn.textContent = 'Choose image';

      // Hide this field's Remove link itself (no photo left to remove).
      var rmBtn = root.querySelector(
        '[data-mf-image-remove][data-mf-property-name="' + name + '"]'
      );
      if (rmBtn) rmBtn.hidden = true;

      // Clear JS state.
      delete photoImages[name];
      delete photoUrls[name];
      delete photoUuids[name];
      photoOffsets[name] = { x: 0, y: 0 };
      // Sync the hole overlay — × badge → + button.
      if (typeof updateHoleOverlayState === 'function') {
        updateHoleOverlayState(name);
      }

      // Clear low-res warning + redraw the plate (this slot is now blank).
      clearLowResWarning(name);
      if (typeof redrawAfterPhotoChange === 'function') redrawAfterPhotoChange();

      // Re-evaluate gate (re-disables ATC if this brings count below total)
      // and persist the new state to localStorage so a refresh stays clean.
      updateAtcGate();
      saveDraftState();
    }

    // Wire the per-photo Remove links.
    root.querySelectorAll('[data-mf-image-remove]').forEach(function (rmBtn) {
      rmBtn.addEventListener('click', function () {
        var name = rmBtn.getAttribute('data-mf-property-name');
        if (!name) return;
        if (window.confirm('Remove this photo?')) removeFieldPhoto(name);
      });
    });

    // ============================================================
    // Add-to-cart gate — image-field templates only
    // ============================================================
    //
    // Block checkout until every image field has a photo. Without this
    // the customer can buy a half-empty design that prints with blank
    // polaroid slots. We run this on init AND after every successful
    // upload, so the gate state always reflects current upload status.
    //
    // Belt-and-braces: we both disable the ATC button (visual + native
    // disabled state) AND intercept its click event in the capture
    // phase (for any payment-button paths that might bypass the
    // disabled state). Plus we add a clear note above the buy area
    // saying exactly how many photos are still missing.
    function countMissingImageFields() {
      if (!HAS_IMAGE_FIELDS) return 0;
      var missing = 0;
      IMAGE_FIELDS.forEach(function (f) {
        var input = root.querySelector(
          '[data-mf-image-cart-url][data-mf-property-name="' + f.property_name + '"]'
        );
        if (!input || !input.value || !input.value.trim()) missing++;
      });
      return missing;
    }

    // ATC button is relocated by sp-personaliser-helpers.js into
    // .sp-tpl-relocate-target, so the canonical reference is just
    // `[name="add"]` anywhere in the document. There's only one per
    // product page (Shopify pattern).
    function findAtcElements() {
      return {
        atc: document.querySelector('[name="add"]'),
        // Shopify dynamic checkout (Shop Pay / PayPal / etc.) buttons —
        // when the gate is closed we visually-mute them too so the
        // customer doesn't sneak past via Shop Pay.
        payButtons: document.querySelector('.shopify-payment-button, .sp-payment-buttons'),
        // Container in the section's bottom area where we'll inject
        // the gate note.
        buyArea: document.querySelector('.sp-tpl-buy'),
      };
    }

    function ensureGateNote(buyArea) {
      if (!buyArea) return null;
      var note = buyArea.querySelector('[data-fb-atc-gate-note]');
      if (note) return note;
      note = document.createElement('p');
      note.className = 'fb-atc-gate-note';
      note.setAttribute('data-fb-atc-gate-note', '');
      // Insert at the top of the buy area so it sits ABOVE the
      // relocated qty/ATC, where the customer's eye will land before
      // they reach for the button.
      buyArea.insertBefore(note, buyArea.firstChild);
      return note;
    }

    function updateAtcGate() {
      if (!HAS_IMAGE_FIELDS) return;
      var els = findAtcElements();
      var missing = countMissingImageFields();
      var total = IMAGE_FIELDS.length;

      if (els.atc) {
        // Enable/disable ALL [name="add"] buttons in the document, not
        // just the first one. The relocation flow can briefly leave
        // multiple references around (the theme's product-form custom
        // element captures its own reference to the button at construct
        // time, and Shop Pay's container may render its own variant in
        // some themes), and only enabling the first leaves the visible
        // button greyed out. Iterating all of them is cheap and robust.
        var allAtc = document.querySelectorAll('[name="add"]');
        if (missing > 0) {
          allAtc.forEach(function (b) {
            b.setAttribute('disabled', 'disabled');
            b.setAttribute('aria-disabled', 'true');
            b.classList.add('fb-atc-gated');
          });
        } else {
          allAtc.forEach(function (b) {
            b.removeAttribute('disabled');
            b.removeAttribute('aria-disabled');
            b.classList.remove('fb-atc-gated');
          });
        }
      }
      if (els.payButtons) {
        els.payButtons.classList.toggle('fb-pay-gated', missing > 0);
      }

      // Sync the start-over button's visibility — only shown when at
      // least one photo has been uploaded.
      updateClearButtonVisibility();

      var note = ensureGateNote(els.buyArea);
      if (note) {
        if (missing > 0) {
          note.textContent = missing === 1
            ? 'Upload your last photo to continue (1 remaining)'
            : 'Upload all ' + total + ' photos to continue (' + missing + ' remaining)';
          note.hidden = false;
        } else {
          note.hidden = true;
          note.textContent = '';
        }
      }
    }

    // Defensive click interceptor — catches click events on the ATC
    // button BEFORE the theme's product-form handler runs. If the gate
    // is closed, swallow the click and surface a brief notice.
    document.addEventListener('click', function (e) {
      if (!HAS_IMAGE_FIELDS) return;
      var target = e.target.closest && e.target.closest('[name="add"]');
      if (!target) return;
      if (countMissingImageFields() > 0) {
        e.preventDefault();
        e.stopPropagation();
        // Re-render the note so the customer sees what's missing.
        updateAtcGate();
        // Scroll the photo controls into view so they can finish.
        var firstEmpty = null;
        for (var i = 0; i < IMAGE_FIELDS.length; i++) {
          var f = IMAGE_FIELDS[i];
          var inp = root.querySelector(
            '[data-mf-image-cart-url][data-mf-property-name="' + f.property_name + '"]'
          );
          if (!inp || !inp.value) {
            firstEmpty = root.querySelector(
              '[data-mf-field-row][data-mf-field-name="' + f.name + '"]'
            );
            break;
          }
        }
        if (firstEmpty && firstEmpty.scrollIntoView) {
          firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, true);

    // Initial gate evaluation. Use rAF so it fires after the
    // sp-personaliser-helpers.js relocator has moved the ATC button
    // into our bottom area; otherwise findAtcElements() may grab the
    // pre-relocation copy and our state changes get reset.
    //
    // We also restore any saved draft state from localStorage at the
    // same point — must run AFTER all helper functions are defined
    // (writeFieldUrl, loadPhoto, etc.) but BEFORE the gate evaluation,
    // so the gate sees the restored URLs and unlocks the ATC if all
    // 5 photos were already in place from a previous session.
    if (HAS_IMAGE_FIELDS) {
      requestAnimationFrame(function () {
        restoreDraftState();
        requestAnimationFrame(updateAtcGate);
      });
    }

    function loadPhoto(name, url) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        // Guard against a stale load (URL changed while we were loading)
        if (photoUrls[name] !== url) return;
        photoImages[name] = img;
        checkPhotoResolution(name, img);
        redrawAfterPhotoChange();
        // Sync the hole overlay — swaps + button for × badge.
        // Defined further down in the file (inside the HAS_IMAGE_FIELDS
        // block), so we check for it before calling.
        if (typeof updateHoleOverlayState === 'function') {
          updateHoleOverlayState(name);
        }
      };
      img.onerror = function () {
        console.warn('[fb-personaliser] photo load failed:', name, url);
      };
      img.src = url;
    }

    // Bootstrap — wire up button clicks + Uploadcare event listeners.
    // Lives inside HAS_IMAGE_FIELDS to keep this dormant on text-only
    // templates (numberplate, seventies edition).
    if (HAS_IMAGE_FIELDS) {
      var ucCtx      = root.querySelector('[data-fb-uc-ctx]');
      var ucUploader = root.querySelector('[data-fb-uc-uploader]');

      // -------------------------------------------------------
      // Hide destructive buttons in Uploadcare's confirm-upload
      // popup — bin (per-file delete) + Clear (clear-all). Customer
      // feedback Jun 2026: both confused users because the X in the
      // top-right of the modal already does the "back out" job;
      // having two destructive actions made people think the bin
      // would just remove the OLD photo (it actually clears the
      // whole upload). Hidden via stylesheet injected into the
      // uploader's shadow root.
      // -------------------------------------------------------
      // Uploadcare destructive buttons (bin / Clear) are hidden via
      // global CSS in the <style> block at the top of this snippet
      // — they render into LIGHT DOM under <uc-file-uploader-regular>
      // so a plain global selector reaches them. No JS injection
      // needed (originally tried shadow-root injection; turned out
      // shadowRoot was null = light DOM).

      // ----- Spatial grid layout -----
      // Position each field's button cell to match where its photo
      // sits on the plate. anchor_x ∈ [0, 1] (left → right) maps to
      // a grid column, anchor_y to a grid row. With (e.g.) Daddy's
      // 5-photo layout — 2 on top, 3 on bottom — this gives:
      //
      //   [Photo 1]              [Photo 2]
      //   [Photo 3]   [Photo 4]  [Photo 5]
      //
      // matching the polaroids' positions on the plate. Without it,
      // the buttons render in field-order (1, 2, 3, 4, 5 left-to-
      // right) which doesn't tell the customer which polaroid each
      // button drives at a glance.
      //
      // We pick the column count dynamically: the largest number of
      // distinct anchor_x positions in any single anchor_y row, capped
      // at 5. Most templates land at 3.
      function positionFieldsSpatially() {
        if (!IMAGE_FIELDS.length) return;
        var fieldsContainer = root.querySelector('.fb-mf-fields');
        if (!fieldsContainer) return;

        // ALWAYS reset inline styles first — handles both desktop→
        // mobile resize (container was set to 3-col, items had explicit
        // placement) and the more subtle "stale state" bug where a
        // previous layout's grid-template-columns lingered on the
        // container even after the items' placements were cleared,
        // so auto-flow on the next pass placed source-order items
        // into the wrong cells.
        fieldsContainer.style.gridTemplateColumns = '';
        IMAGE_FIELDS.forEach(function (f) {
          var el = root.querySelector(
            '[data-mf-field-row][data-mf-field-name="' + f.name + '"]'
          );
          if (el) { el.style.gridColumn = ''; el.style.gridRow = ''; }
        });

        // Skip spatial layout when the container is narrow — auto-flow
        // into 2 columns (driven by the CSS @media rule) reads cleaner
        // than a 3-column grid full of empty cells. Use the container's
        // actual width rather than the viewport so this works correctly
        // when the personaliser sits inside a narrower wrapper than the
        // viewport itself (e.g. on tablets where the editor is in a
        // padded card much narrower than the viewport).
        if (fieldsContainer.clientWidth < 600) return;

        // Special case for low-field-count templates (≤ 3 image fields):
        // single row of N columns sorted by anchor_x. Stacking 3 photos
        // in 3 separate rows wastes vertical space and reads less well
        // than placing them side-by-side in plate-x order. Skips the
        // row-clustering pass below (which would otherwise put each
        // distinct anchor_y into its own row).
        if (IMAGE_FIELDS.length <= 3) {
          var lowN = IMAGE_FIELDS.length;
          fieldsContainer.style.gridTemplateColumns = 'repeat(' + lowN + ', 1fr)';
          IMAGE_FIELDS.slice()
            .sort(function (a, b) {
              return (a.anchor_x != null ? a.anchor_x : 0.5) -
                     (b.anchor_x != null ? b.anchor_x : 0.5);
            })
            .forEach(function (f, idx) {
              var el = root.querySelector(
                '[data-mf-field-row][data-mf-field-name="' + f.name + '"]'
              );
              if (el) {
                el.style.gridColumn = String(idx + 1);
                el.style.gridRow    = '1';
              }
            });
          return;
        }

        // Cluster fields by anchor_y (within tolerance) into rows.
        // Tolerance 0.10 is tight enough to put genuinely-distinct
        // vertical positions into separate rows (e.g. BDE has a
        // mid-row polaroid at y=0.45 that should NOT lump with the
        // top row at y=0.30) while still grouping near-duplicates
        // from tilted polaroid layouts (Daddy's bottom row varies
        // y=0.61–0.63 due to tilts but should stay one row).
        var Y_TOL = 0.10;
        var rows = []; // [{ y: <avg>, fields: [...] }]
        IMAGE_FIELDS.slice()
          .sort(function (a, b) { return (a.anchor_y || 0.5) - (b.anchor_y || 0.5); })
          .forEach(function (f) {
            var y = f.anchor_y != null ? f.anchor_y : 0.5;
            var bucket = null;
            for (var i = 0; i < rows.length; i++) {
              if (Math.abs(rows[i].y - y) < Y_TOL) { bucket = rows[i]; break; }
            }
            if (!bucket) { bucket = { y: y, fields: [] }; rows.push(bucket); }
            bucket.fields.push(f);
          });

        // Column count = max polaroids in any row, clamped to [1, 5].
        var nCols = 1;
        rows.forEach(function (r) { if (r.fields.length > nCols) nCols = r.fields.length; });
        nCols = Math.max(1, Math.min(5, nCols));
        // Force a minimum of 3 cols when the template's polaroids span
        // a wide x range — e.g. Daddy top row has 2 polaroids but they
        // sit at x=0.31 and x=0.68, so dropping into a 2-col grid
        // squashes them together. A 3-col grid with cols 1+3 captures
        // the gap correctly.
        var maxX = 0, minX = 1;
        IMAGE_FIELDS.forEach(function (f) {
          var x = f.anchor_x != null ? f.anchor_x : 0.5;
          if (x > maxX) maxX = x;
          if (x < minX) minX = x;
        });
        if ((maxX - minX) > 0.5 && nCols < 3) nCols = 3;

        fieldsContainer.style.gridTemplateColumns = 'repeat(' + nCols + ', 1fr)';

        // Collision avoidance — two fields with similar anchor_x in
        // the same row would otherwise stack on top of each other in
        // the same grid cell. Track used (row, col) pairs; if a
        // collision is detected, try shifting the second field to
        // an adjacent free column in the same row, then fall back
        // to CSS auto-flow if no neighbour is free.
        //
        // Within each row we process fields LEFT-TO-RIGHT (sorted by
        // anchor_x) so the leftmost-anchored field claims its natural
        // column first. Without this sort, the row's processing order
        // is whatever fell out of the upstream y-sort — which can put
        // a right-side field ahead of a left-side one (e.g. grandma-
        // pink-mug: photo_4 y=0.7028 vs photo_3 y=0.7035 → photo_4
        // gets processed first, grabs the centre col, photo_3 then
        // collides and walks outward to the RIGHT, ending up on the
        // far right of the form despite being the bottom-LEFT photo).
        // Sorting by anchor_x means collisions only ever push fields
        // further out FROM their geometric direction, not across it.
        //
        // The collision walker is also biased by anchor_x: left-half
        // fields prefer to walk left when displaced, right-half fields
        // prefer to walk right. Keeps near-centre fields from landing
        // on the wrong side when their natural column is taken.
        var used = {}; // "row:col" → true
        rows.forEach(function (row, rowIdx) {
          row.fields.slice()
            .sort(function (a, b) {
              return (a.anchor_x != null ? a.anchor_x : 0.5) -
                     (b.anchor_x != null ? b.anchor_x : 0.5);
            })
            .forEach(function (f) {
            var x = f.anchor_x != null ? f.anchor_x : 0.5;
            // Map x ∈ [0, 1] → col ∈ [1, nCols]
            var col = Math.floor(x * nCols) + 1;
            if (col < 1) col = 1;
            if (col > nCols) col = nCols;
            var rowNum = rowIdx + 1;
            var key = rowNum + ':' + col;

            // If the desired cell is taken, walk outward looking for
            // a free column in the same row. Direction of walk is
            // biased by the field's anchor_x: left-half (x<0.5)
            // prefers leftward, right-half prefers rightward.
            if (used[key]) {
              var found = false;
              var walkRight = (x >= 0.5);
              for (var off = 1; off < nCols; off++) {
                var candidates = walkRight
                  ? [col + off, col - off]
                  : [col - off, col + off];
                for (var ci = 0; ci < candidates.length; ci++) {
                  var c = candidates[ci];
                  if (c < 1 || c > nCols) continue;
                  var k2 = rowNum + ':' + c;
                  if (!used[k2]) { col = c; key = k2; found = true; break; }
                }
                if (found) break;
              }
              // No free column in this row — fall back to CSS auto-flow
              // for this field (clear its inline placement).
              if (!found) col = null;
            }

            var el = root.querySelector(
              '[data-mf-field-row][data-mf-field-name="' + f.name + '"]'
            );
            if (el) {
              if (col != null) {
                el.style.gridColumn = String(col);
                el.style.gridRow    = String(rowNum);
                used[key] = true;
              } else {
                // Auto-flow this field — CSS will place it in the next
                // available cell.
                el.style.gridColumn = '';
                el.style.gridRow    = '';
              }
            }
          });
        });
      }
      positionFieldsSpatially();
      // Re-position on viewport resize (handles desktop ↔ mobile swap).
      var posDebounce = null;
      window.addEventListener('resize', function () {
        clearTimeout(posDebounce);
        posDebounce = setTimeout(positionFieldsSpatially, 150);
      });

      // Per-field thumbnail tap → forward to the matching button so
      // the customer can tap the small thumbnail (or the big polaroid
      // on the plate, handled inside setupPhotoDrag) to re-open the
      // upload modal. Same effect as clicking "Change / Edit Image".
      root.querySelectorAll('[data-mf-image-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var name = thumb.getAttribute('data-mf-property-name');
          var btn  = root.querySelector(
            '[data-mf-image-btn][data-mf-property-name="' + name + '"]'
          );
          if (btn) btn.click();
        });
      });

      // Resolve Uploadcare's API regardless of whether it returns a
      // Promise (newer builds) or an object directly (older). callback
      // gets the resolved API or null if unavailable.
      function withUcApi(callback) {
        var src = ucCtx || ucUploader;
        if (!src || typeof src.getAPI !== 'function') { callback(null); return; }
        try {
          var api = src.getAPI();
          if (api && typeof api.then === 'function') {
            api.then(callback, function () { callback(null); });
          } else {
            callback(api || null);
          }
        } catch (e) {
          console.warn('[fb-personaliser] getAPI threw:', e);
          callback(null);
        }
      }

      // Open the Uploadcare modal targeted at a specific field.
      // Two flows depending on whether the field already has a photo:
      //
      //   - EMPTY field ("Choose image"): clear the collection + open
      //     the modal. Modal shows the source picker (From device /
      //     Camera / Dropbox / etc.). Customer picks a file, cloud
      //     editor runs for crop/rotate/tune, file uploads.
      //
      //   - FILLED field ("Edit image"): clear the collection + add
      //     this field's existing UUID + open the modal. Modal shows
      //     the file-management view with the existing photo and a
      //     pencil for editing. Customer clicks pencil, edits, hits
      //     Done — the cdnUrl now carries the transform operators
      //     (e.g. /-/crop/.../) and our success handler writes the
      //     updated URL into this field's inputs.
      //
      // Changing TO a different file isn't done from this modal — the
      // customer clicks the "✕ Remove" link first to wipe the slot,
      // then "Choose image" opens the fresh source picker.
      function openUploaderForField(name) {
        activeFieldName = name;
        var existingUuid = photoUuids[name] || null;

        withUcApi(function (api) {
          if (api) {
            try {
              if (typeof api.removeAllFiles === 'function') api.removeAllFiles();
              if (existingUuid && typeof api.addFileFromUuid === 'function') {
                api.addFileFromUuid(existingUuid);
              }
              if (typeof api.initFlow === 'function') {
                api.initFlow();
                return;
              }
            } catch (e) {
              console.warn('[fb-personaliser] API call sequence threw:', e);
            }
          }
          // Fallback: nothing on the ctx API worked — try clicking the
          // hidden uploader element. Won't have per-field isolation but
          // at least opens something.
          if (ucUploader) {
            try { ucUploader.click(); }
            catch (e) { console.warn('[fb-personaliser] uploader.click() threw:', e); }
          } else {
            console.error('[fb-personaliser] Could not open Uploadcare flow.');
          }
        });
      }

      // Per-field button → open the modal targeted at this field.
      root.querySelectorAll('[data-mf-image-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openUploaderForField(btn.getAttribute('data-mf-property-name'));
        });
      });

      // Listen on both the ctx provider AND the file-uploader element
      // because different builds dispatch on different targets. Handler
      // bails out if no active field is set, so duplicate fires are safe.
      var ucTargets = [ucCtx, ucUploader].filter(Boolean);
      var ucEvents  = ['file-upload-success', 'common-upload-success'];
      ucTargets.forEach(function (t) {
        ucEvents.forEach(function (ev) {
          t.addEventListener(ev, handleUploadcareSuccess);
        });
      });
    }

    // ============================================================
    // Low-resolution photo warning
    // ============================================================
    //
    // Compute the cover-fit cropped pixels of the uploaded photo and
    // compare against the print pixels needed for that hole on the
    // LARGEST available mug variant (so the warning is consistent
    // regardless of which size the customer picks). If the photo's
    // cropped region is smaller than required, show a non-blocking
    // amber warning + corner badge.
    //
    // 20oz is the largest variant in the print spec table — 270mm x
    // 115mm. At 300 DPI:
    //   width:  270 / 25.4 * 300 ≈ 3189 px
    //   height: 115 / 25.4 * 300 ≈ 1359 px
    var LARGEST_PRINT_PX = { w: 3189, h: 1359 };

    function checkPhotoResolution(propertyName, img) {
      // Find the matching field schema entry.
      var field = null;
      for (var i = 0; i < IMAGE_FIELDS.length; i++) {
        if (IMAGE_FIELDS[i].property_name === propertyName) {
          field = IMAGE_FIELDS[i];
          break;
        }
      }
      if (!field) return;

      var holeFracW = field.width_frac  != null ? field.width_frac  : 0.5;
      var holeFracH = field.height_frac != null ? field.height_frac : 0.5;
      var holePrintW = holeFracW * LARGEST_PRINT_PX.w;
      var holePrintH = holeFracH * LARGEST_PRINT_PX.h;
      var holeAspect = holePrintW / holePrintH;
      var imgAspect  = img.width / img.height;

      // Cover-fit gives the cropped source dimensions actually used.
      var sw, sh;
      if (imgAspect > holeAspect) {
        sh = img.height;
        sw = sh * holeAspect;
      } else {
        sw = img.width;
        sh = sw / holeAspect;
      }

      // 5% tolerance — being just slightly under the required pixel
      // count is fine in practice (customers don't notice a 5%
      // upscale).
      var isLowRes = sw < holePrintW * 0.95 || sh < holePrintH * 0.95;
      updateLowResWarning(field, isLowRes);
    }

    function updateLowResWarning(field, isLowRes) {
      var row = root.querySelector(
        '[data-mf-field-row][data-mf-field-name="' + field.name + '"]'
      );
      if (!row) return;
      // Toggle attribute — only write if state differs to avoid
      // triggering the MutationObserver unnecessarily.
      var has = row.hasAttribute('data-fb-low-res');
      if (isLowRes && !has) row.setAttribute('data-fb-low-res', 'true');
      if (!isLowRes && has) row.removeAttribute('data-fb-low-res');

      var warning = row.querySelector('[data-mf-image-warning]');
      if (warning && warning.hidden !== !isLowRes) {
        warning.hidden = !isLowRes;
      }
    }

    function clearLowResWarning(propertyName) {
      var field = null;
      for (var i = 0; i < IMAGE_FIELDS.length; i++) {
        if (IMAGE_FIELDS[i].property_name === propertyName) {
          field = IMAGE_FIELDS[i];
          break;
        }
      }
      if (field) updateLowResWarning(field, false);
    }

    // Texture redraw + flat preview + cylinder views in one shot. Called
    // after any photo upload completes or is removed. renderAll exists
    // further down, but JS hoisting makes it callable from here.
    function redrawAfterPhotoChange() {
      renderTextureMain();
      if (typeof renderAll === 'function') renderAll();
      updateGalleryPhotoState();
    }

    // Toggle the gallery's `fb-has-photos` class based on whether any
    // customer photo is currently loaded. The CSS uses this class to
    // fade out the default-state product image overlay (image-field
    // templates only — other templates don't render the overlay).
    function updateGalleryPhotoState() {
      var galleryEl = document.querySelector('[data-fb-photo-default]');
      if (!galleryEl) return;
      var hasAny = false;
      for (var k in photoImages) {
        if (photoImages.hasOwnProperty(k) && photoImages[k]) { hasAny = true; break; }
      }
      var alreadyOn = galleryEl.classList.contains('fb-has-photos');
      if (hasAny !== alreadyOn) {
        galleryEl.classList.toggle('fb-has-photos', hasAny);
      }
    }

    // ============================================================
    // Drag-to-reposition (image-field templates only)
    // ============================================================
    //
    // Customers drag any uploaded photo within its polaroid hole on
    // the flat preview to reframe the crop. Cover-fit math stays the
    // same; we just shift the source-image crop window by the offset
    // the customer accumulates during drag. Offset is normalised to
    // [-1, 1] per axis so it's independent of canvas display size.
    //
    // Solves a real-world issue: customers don't always realise they
    // can crop their photo in the upload modal before submitting, so
    // heads get cut off and Danni has to manually re-crop and re-print.
    function clamp(v, lo, hi) {
      return v < lo ? lo : (v > hi ? hi : v);
    }
    function getPhotoOffset(name) {
      if (!photoOffsets[name]) photoOffsets[name] = { x: 0, y: 0 };
      return photoOffsets[name];
    }
    function writeOffsetProperty(name) {
      var off = getPhotoOffset(name);
      var inp = root.querySelector(
        '[data-mf-image-offset][data-mf-property-name="' + name + '"]'
      );
      if (inp) inp.value = off.x.toFixed(3) + ',' + off.y.toFixed(3);
    }

    // Hit-test a flat-preview point against image fields' holes.
    // Coords are normalised (0..1 across canvas dimensions). Returns
    // the matching field, or null.
    function hitTestImageHole(nx, ny) {
      var found = null;
      IMAGE_FIELDS.forEach(function (field) {
        if (!photoImages[field.property_name]) return; // can't drag what isn't there
        var ax = field.anchor_x != null ? field.anchor_x : 0.5;
        var ay = field.anchor_y != null ? field.anchor_y : 0.5;
        var hw = field.width_frac  != null ? field.width_frac  : 0.5;
        var hh = field.height_frac != null ? field.height_frac : 0.5;
        // Account for the field's own rotation (rare for image fields).
        // For zero rotation, this is a simple bounds check.
        var dx = nx - ax;
        var dy = ny - ay;
        var rotRad = (parseFloat(field.rotation) || 0) * Math.PI / 180;
        if (rotRad) {
          var c = Math.cos(-rotRad), s = Math.sin(-rotRad);
          var rx = dx * c - dy * s;
          var ry = dx * s + dy * c;
          dx = rx; dy = ry;
        }
        if (Math.abs(dx) <= hw / 2 && Math.abs(dy) <= hh / 2) {
          found = field;
        }
      });
      return found;
    }

    // Wire the drag handlers onto the flat preview canvas.
    function setupPhotoDrag() {
      if (!HAS_IMAGE_FIELDS || !flatPreview) return;
      flatPreview.style.touchAction = 'none';
      flatPreview.classList.add('fb-flat-preview--draggable');

      var dragState = null;

      function setCursorFromPoint(clientX, clientY) {
        if (dragState) return; // grabbing already
        var rect = flatPreview.getBoundingClientRect();
        var nx = (clientX - rect.left) / rect.width;
        var ny = (clientY - rect.top)  / rect.height;
        var hit = hitTestImageHole(nx, ny);
        // Pointer changes to indicate the photo is interactive: grab
        // on hover (you can drag), pointer when no photo present yet
        // but we still want to suggest "click here to upload" — fall
        // back to default cursor in that case.
        flatPreview.style.cursor = hit ? 'grab' : '';
      }

      // Tap-vs-drag detection threshold: pointerup within this many
      // pixels of pointerdown is treated as a tap (opens the upload
      // modal for that photo's field). Anything more = a drag.
      var TAP_PX_THRESHOLD = 6;

      flatPreview.addEventListener('pointermove', function (e) {
        if (!dragState) {
          setCursorFromPoint(e.clientX, e.clientY);
          return;
        }
        var rect = flatPreview.getBoundingClientRect();
        // Translate canvas-pixel drag delta to a [-1, 1] offset shift.
        // dx of one full hole-width in canvas = -1 offset shift on x
        // (pan metaphor: dragging photo right reveals its left side).
        var dxFrac = (e.clientX - dragState.startX) / rect.width;
        var dyFrac = (e.clientY - dragState.startY) / rect.height;
        var holeW  = dragState.field.width_frac  || 0.5;
        var holeH  = dragState.field.height_frac || 0.5;
        var off = getPhotoOffset(dragState.field.property_name);
        off.x = clamp(dragState.startOffset.x - dxFrac / holeW * 2, -1, 1);
        off.y = clamp(dragState.startOffset.y - dyFrac / holeH * 2, -1, 1);
        // Track total movement so pointerup can decide tap vs drag.
        var moveDx = e.clientX - dragState.startX;
        var moveDy = e.clientY - dragState.startY;
        if (Math.abs(moveDx) > TAP_PX_THRESHOLD || Math.abs(moveDy) > TAP_PX_THRESHOLD) {
          dragState.didDrag = true;
        }
        writeOffsetProperty(dragState.field.property_name);
        renderTextureMain();
        if (typeof renderAll === 'function') renderAll();
      });

      flatPreview.addEventListener('pointerdown', function (e) {
        var rect = flatPreview.getBoundingClientRect();
        var nx = (e.clientX - rect.left) / rect.width;
        var ny = (e.clientY - rect.top)  / rect.height;
        var hit = hitTestImageHole(nx, ny);
        if (!hit) return;
        e.preventDefault();
        flatPreview.setPointerCapture(e.pointerId);
        dragState = {
          field:       hit,
          pointerId:   e.pointerId,
          startX:      e.clientX,
          startY:      e.clientY,
          startOffset: { x: getPhotoOffset(hit.property_name).x, y: getPhotoOffset(hit.property_name).y },
          didDrag:     false,
        };
        flatPreview.style.cursor = 'grabbing';
      });

      function endDrag(e) {
        if (!dragState) return;
        var fieldName  = dragState.field.property_name;
        var wasTap     = !dragState.didDrag;
        try { flatPreview.releasePointerCapture(dragState.pointerId); } catch (_) {}
        dragState = null;
        setCursorFromPoint(e.clientX, e.clientY);

        // Tap on a photo (no drag) → open the upload modal for that
        // field, same as clicking the field's "Change / Edit Image"
        // button. Customers naturally want to tap a photo to edit it,
        // so route that intent into the existing change-image flow.
        if (wasTap) {
          var btn = root.querySelector(
            '[data-mf-image-btn][data-mf-property-name="' + fieldName + '"]'
          );
          if (btn) btn.click();
        }
      }
      flatPreview.addEventListener('pointerup',     endDrag);
      flatPreview.addEventListener('pointercancel', endDrag);
    }
    setupPhotoDrag();

    // ============================================================
    // Click-the-hole upload UX
    // ------------------------------------------------------------
    // Build an overlay layer inside .fb-flat-preview-wrap with one
    // button per image field. Empty hole → big + button. Filled
    // hole → small × badge (canvas drag handler still owns the
    // rest of the hole for repositioning). Click handlers forward
    // to the existing data-mf-image-btn / data-mf-image-remove
    // buttons so the Uploadcare flow stays unchanged.
    // ============================================================
    function setupHoleOverlays() {
      if (!HAS_IMAGE_FIELDS || !flatPreview) return;
      var wrap = flatPreview.parentNode;
      if (!wrap) return;

      // Container — one per snippet instance. If we've already
      // built it (e.g. on a re-init), tear it down first.
      var existing = wrap.querySelector('[data-fb-hole-overlays]');
      if (existing) existing.parentNode.removeChild(existing);

      var container = document.createElement('div');
      container.className = 'fb-hole-overlays';
      container.setAttribute('data-fb-hole-overlays', '');
      wrap.appendChild(container);

      IMAGE_FIELDS.forEach(function (field) {
        var name = field.property_name;
        if (!name) return;

        var ax = field.anchor_x != null ? field.anchor_x : 0.5;
        var ay = field.anchor_y != null ? field.anchor_y : 0.5;
        var hw = field.width_frac  != null ? field.width_frac  : 0.5;
        var hh = field.height_frac != null ? field.height_frac : 0.5;
        var rot = parseFloat(field.rotation) || 0;

        var overlay = document.createElement('div');
        overlay.className   = 'fb-hole-overlay is-empty';
        overlay.setAttribute('data-fb-hole-overlay', '');
        overlay.setAttribute('data-mf-property-name', name);
        // Percentage-based positioning anchors the overlay to the
        // canvas's rendered size — no need to recompute on resize.
        overlay.style.left   = ((ax - hw / 2) * 100) + '%';
        overlay.style.top    = ((ay - hh / 2) * 100) + '%';
        overlay.style.width  = (hw * 100) + '%';
        overlay.style.height = (hh * 100) + '%';
        if (rot) overlay.style.transform = 'rotate(' + rot + 'deg)';

        // Add button (full-hole tap → trigger the upload flow).
        var addBtn = document.createElement('button');
        addBtn.type      = 'button';
        addBtn.className = 'fb-hole-add';
        addBtn.setAttribute('aria-label', 'Add ' + name);
        addBtn.innerHTML =
          '<span class="fb-hole-add__icon" aria-hidden="true">+</span>' +
          '<span class="fb-hole-add__label">Add photo</span>';
        addBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var btn = root.querySelector(
            '[data-mf-image-btn][data-mf-property-name="' + name + '"]'
          );
          if (btn) btn.click();
        });
        overlay.appendChild(addBtn);

        // Remove badge (× in the corner of filled holes).
        var rmBtn = document.createElement('button');
        rmBtn.type      = 'button';
        rmBtn.className = 'fb-hole-remove';
        rmBtn.setAttribute('aria-label', 'Remove ' + name);
        rmBtn.textContent = '×'; // multiplication sign — visually a clean ×
        rmBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var btn = root.querySelector(
            '[data-mf-image-remove][data-mf-property-name="' + name + '"]'
          );
          if (btn) btn.click();
        });
        overlay.appendChild(rmBtn);

        container.appendChild(overlay);
      });

      // Initial state sync — any photos already loaded (e.g. from
      // localStorage on refresh) should show their × badge, not the
      // + button.
      IMAGE_FIELDS.forEach(function (field) {
        updateHoleOverlayState(field.property_name);
      });
    }

    // Toggle a specific hole overlay between empty (+ button) and
    // filled (× badge) based on whether a photo's currently loaded
    // for that field. Cheap, idempotent — safe to call repeatedly.
    function updateHoleOverlayState(name) {
      var overlay = root.querySelector(
        '[data-fb-hole-overlay][data-mf-property-name="' + name + '"]'
      );
      if (!overlay) return;
      var filled = !!photoImages[name];
      overlay.classList.toggle('is-filled', filled);
      overlay.classList.toggle('is-empty',  !filled);
    }

    setupHoleOverlays();

    // ---- Calibration (merge shared + per-view) ----
    var SHARED = TPL.shared;

    // ============================================================
    // Name-presence mesh adjust (British Escapes)
    // ============================================================
    // When a name is present the artwork lifts + shrinks to make room for
    // it (calibrated mesh_y/mesh_scale). Stored as absolute "with name"
    // values; applied as a delta on top of whatever mug shape is active,
    // so it behaves on ceramic/latte/travel alike. Templates without
    // name_present_overrides leave NAME_OVERRIDES null and this is a no-op.
    var NAME_OVERRIDES = TPL.name_present_overrides || null;
    var nameShapeBaseY     = (SHARED.mesh_y != null ? SHARED.mesh_y : 0);
    var nameShapeBaseScale = (SHARED.mesh_scale != null ? SHARED.mesh_scale : 1);
    // Independent design-image transform base (restored when no name present).
    var nameShapeBaseDesignScale   = (SHARED.design_scale    != null ? SHARED.design_scale    : 1);
    var nameShapeBaseDesignOffsetY = (SHARED.design_offset_y != null ? SHARED.design_offset_y : 0);
    // 2026-08-20 — extended name overrides for Dog Portrait. Base values so we
    // can restore without-name state after an override was applied.
    var nameShapeBaseScaleY = (SHARED.mesh_scale_y  != null ? SHARED.mesh_scale_y  : 1);
    var nameShapeBaseAspect = (SHARED.design_aspect != null ? SHARED.design_aspect : 1);
    function fbNameIsPresent() {
      var el = root.querySelector('[data-mf-input][data-mf-field-name="name"]');
      return !!(el && el.value && el.value.trim().length);
    }
    // Per-shape "with name" override, keyed by the active size key
    // (null/primary = ceramic, "12oz Latte", "Travel Mug"). Falls back to
    // the primary entry if a shape has none.
    function fbNameOverride() {
      if (!NAME_OVERRIDES) return null;
      var key = (typeof currentShapeKey !== 'undefined' && currentShapeKey) ? currentShapeKey : 'primary';
      return NAME_OVERRIDES[key] || NAME_OVERRIDES['primary'] || null;
    }
    // Name present -> snap to that shape's tuned "with name" mesh; absent
    // -> restore the shape's no-name base. Travel's override equals its
    // base, so it simply doesn't move.
    function applyNameMesh() {
      if (!NAME_OVERRIDES) return;
      var on = fbNameIsPresent();
      var ov = fbNameOverride();
      var prevAspect = SHARED.design_aspect;
      if (on && ov) {
        if (ov.mesh_y       != null) SHARED.mesh_y       = ov.mesh_y;
        if (ov.mesh_scale   != null) SHARED.mesh_scale   = ov.mesh_scale;
        if (ov.mesh_scale_y != null) SHARED.mesh_scale_y = ov.mesh_scale_y;
        SHARED.design_scale    = (ov.design_scale    != null) ? ov.design_scale    : nameShapeBaseDesignScale;
        SHARED.design_offset_y = (ov.design_offset_y != null) ? ov.design_offset_y : nameShapeBaseDesignOffsetY;
        if (ov.design_aspect != null) SHARED.design_aspect = ov.design_aspect;
      } else {
        SHARED.mesh_y        = nameShapeBaseY;
        SHARED.mesh_scale    = nameShapeBaseScale;
        SHARED.mesh_scale_y  = nameShapeBaseScaleY;
        SHARED.design_scale  = nameShapeBaseDesignScale;
        SHARED.design_offset_y = nameShapeBaseDesignOffsetY;
        SHARED.design_aspect = nameShapeBaseAspect;
      }
      // design_aspect changes the cylinder geometry → force a rebuild
      // when the value crossed the with/without-name boundary.
      var rebuild = (SHARED.design_aspect !== prevAspect);
      if (typeof applySharedToScene === 'function') applySharedToScene(rebuild);
    }
    var VIEW_CAL = TPL.views || {};
    var VIEWS = ['left', 'centre', 'right'].map(function (id) {
      var v = VIEW_CAL[id] || {};
      var clip = v.clip || [30, 70, 10, 78, 0, 0];
      return {
        id: id,
        rotationOffset: v.rotation_offset != null ? v.rotation_offset : 0,
        // Per-view roll correction — each blank-mug photo can have its own
        // slight camera roll, so the correction is applied at render time
        // as SHARED.mesh_roll + view.rollOffset (effective Z rotation).
        rollOffset:     v.roll_offset != null ? v.roll_offset : 0,
        clipLeft: clip[0], clipRight: clip[1],
        clipTop:  clip[2], clipBottom: clip[3],
        // Slants displace the BOTTOM corners inward (positive) or outward
        // (negative) relative to the top corners — turns the rectangle into
        // a trapezoid so the clip can follow the mug body's taper.
        clipLeftSlant:  clip[4] || 0,
        clipRightSlant: clip[5] || 0,
      };
    });

    // ---- Texture canvases (design layer + customer content composite) ----
    //
    // Two-canvas architecture so any single-side design template can be
    // duplicated for "wraps around both sides" use cases without the
    // template author having to lay out a wide bare image:
    //
    //   singleSideCanvas — ONE clean instance of (design + fields). This
    //                      is what the customer's flat preview shows.
    //                      Always at design's natural aspect.
    //   textureCanvas    — singleSideCanvas tiled `repeat_x` times. Used
    //                      by Three.js as the cylinder texture, so the
    //                      cylinder wraps with multiple instances visible
    //                      from different angles.
    //
    // For repeat_x = 1 (numberplate templates), textureCanvas content is
    // a single copy of singleSideCanvas — visually identical, no overhead.
    // For repeat_x = 2 (seventies edition etc.), textureCanvas holds two
    // copies side by side, so the cylinder shows the design on both sides
    // of the mug.
    var TEXTURE_W = 4096;
    var textureCanvas    = document.createElement('canvas');
    var tctx             = textureCanvas.getContext('2d');
    var singleSideCanvas = document.createElement('canvas');
    var ssCtx            = singleSideCanvas.getContext('2d');
    // Offscreen canvas for text-only weathering passes (destination-out
    // operations on text without affecting the design layer underneath).
    var textCanvas = document.createElement('canvas');
    var textCtx    = textCanvas.getContext('2d');

    function resizeTextureCanvas() {
      var repeats = Math.max(1, Math.round(SHARED.repeat_x || 1));

      // textureCanvas: full TEXTURE_W width holds N instances tiled
      textureCanvas.width  = TEXTURE_W;
      textureCanvas.height = Math.round(TEXTURE_W / (SHARED.design_aspect * repeats));

      // singleSideCanvas: 1/Nth the width — one instance at design's natural aspect
      singleSideCanvas.width  = Math.round(TEXTURE_W / repeats);
      singleSideCanvas.height = textureCanvas.height;

      // textCanvas matches singleSideCanvas (per-instance offscreen scratch)
      textCanvas.width  = singleSideCanvas.width;
      textCanvas.height = singleSideCanvas.height;

      // Flat preview shows ONE instance (single-side aspect)
      if (flatPreview) flatPreview.style.aspectRatio = SHARED.design_aspect;
    }
    resizeTextureCanvas();

    // Look up the size cap for a given character length. Uses the smallest
    // key >= len so templates can declare a sparse caps map (e.g. {3, 5,
    // 8, 12}) without every length needing an explicit entry. Falls back
    // to `fallback` when len exceeds every declared key.
    function capForLength(sizeCaps, len, fallback) {
      if (!sizeCaps) return fallback;
      var keys = Object.keys(sizeCaps)
        .map(function (k) { return parseInt(k, 10); })
        .filter(function (n) { return !isNaN(n); })
        .sort(function (a, b) { return a - b; });
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] >= len) return sizeCaps[String(keys[i])];
      }
      return fallback;
    }

    // Seeded PRNG so the weathering pattern is deterministic for a given
    // text — same input = same wear, no noise jittering on every keystroke.
    function mulberry32(seed) {
      return function () {
        var t = seed = (seed + 0x6D2B79F5) | 0;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    // Apply procedural wear to whatever's on `ctx` by chipping pixels away
    // with destination-out. Mixes large blobs (paint loss) + small speckles
    // (pock-marks) + horizontal scratches. Bounded to a rectangle (the text
    // bounding box) so we don't waste cycles on transparent areas.
    //
    //   intensity  0..1  — overall amount of wear
    //   x,y,w,h          — region to weather (in canvas pixels)
    //   seed             — PRNG seed (text length is fine; same input → same look)
    function applyWeathering(ctx, x, y, w, h, intensity, seed) {
      if (intensity <= 0 || w <= 0 || h <= 0) return;
      var rand = mulberry32(seed | 0);
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';

      // Large blobs — chunks of paint loss
      var blobCount = Math.floor(60 * intensity);
      for (var i = 0; i < blobCount; i++) {
        var bx = x + rand() * w;
        var by = y + rand() * h;
        var rx = (10 + rand() * 35) * (0.5 + intensity);
        var ry = rx * (0.4 + rand() * 0.6);
        ctx.fillStyle = 'rgba(0,0,0,' + (0.35 + rand() * 0.5) + ')';
        ctx.beginPath();
        ctx.ellipse(bx, by, rx, ry, rand() * Math.PI, 0, Math.PI * 2);
        ctx.fill();
      }

      // Small speckles — fine pock-marks, much higher count, low alpha
      var speckCount = Math.floor((w * h) * 0.00002 * intensity);
      for (var j = 0; j < speckCount; j++) {
        var sx = x + rand() * w;
        var sy = y + rand() * h;
        var sr = 1 + rand() * 4;
        ctx.fillStyle = 'rgba(0,0,0,' + (0.2 + rand() * 0.5) + ')';
        ctx.beginPath();
        ctx.arc(sx, sy, sr, 0, Math.PI * 2);
        ctx.fill();
      }

      // Horizontal scratches — long thin lines across the surface
      var scratchCount = Math.floor(20 * intensity);
      for (var k = 0; k < scratchCount; k++) {
        var stx = x + rand() * w;
        var sty = y + rand() * h;
        var sw  = 80 + rand() * 280;
        var sh  = 1 + rand() * 3;
        ctx.fillStyle = 'rgba(0,0,0,' + (0.4 + rand() * 0.5) + ')';
        ctx.fillRect(stx, sty, sw, sh);
      }

      ctx.restore();
    }

    // Paint the flat preview from the texture canvas. Called after each
    // texture render so the customer sees their plate update live.
    function paintFlatPreview() {
      if (!flatPreview || !flatCtx) return;
      var displayW = flatPreview.clientWidth;
      if (displayW === 0) return;
      var dpr = window.devicePixelRatio || 1;
      var bw = Math.round(displayW * dpr);
      var bh = Math.round(bw / SHARED.design_aspect);
      if (flatPreview.width !== bw || flatPreview.height !== bh) {
        flatPreview.width  = bw;
        flatPreview.height = bh;
      }
      flatCtx.clearRect(0, 0, bw, bh);
      // Multi-field templates show ONE clean instance from the single-side
      // canvas (no seams or split halves). Single-text templates show the
      // texture canvas directly — same visual result since repeat_x = 1.
      var source = IS_MF ? singleSideCanvas : textureCanvas;
      flatCtx.drawImage(source, 0, 0, bw, bh);
    }

    // ============================================================
    // Customer font picker (Flavour 1 — global override)
    // ============================================================
    // When a template declares `content_schema.font_options`, the
    // Liquid renders a "Font style" <select> at the top of the field
    // list. JS tracks its value and overrides EVERY text/select field's
    // baked-in `font` at render time, so the customer's pick uniformly
    // restyles the whole design.
    //
    // Templates without font_options leave this block as a no-op —
    // CUSTOMER_FONT stays null and getEffectiveFont(field) returns
    // field.font unchanged.
    var fontPickerEl = root.querySelector('[data-mf-font-picker]');
    var fontPropEl   = root.querySelector('[data-mf-font-picker-property]');
    var CUSTOMER_FONT = fontPickerEl ? fontPickerEl.value : null;

    function getEffectiveFont(field) {
      // Customer override wins when active. Falls back to the field's
      // baked font, then to charles-wright as a last-resort default.
      return CUSTOMER_FONT || field.font || 'charles-wright';
    }

    function updateFontProperty() {
      if (!fontPickerEl || !fontPropEl) return;
      var opt = fontPickerEl.options[fontPickerEl.selectedIndex];
      fontPropEl.value = opt ? (opt.textContent || opt.label || opt.value) : '';
    }

    if (fontPickerEl) {
      // Seed the property input with the default option's label so
      // a customer who never touches the picker still has it submit.
      updateFontProperty();

      // Pre-warm every font in the picker at boot so the first switch
      // renders correctly. Without this, the browser only fetches a web
      // font on first CSS use, and canvas rendering that happens BEFORE
      // the font arrives falls back to Comic Sans. That's what surfaces
      // as "the first time I pick Amatic it looks wrong; second time is
      // fine" — the second render uses the now-cached face. Pre-warming
      // fires the fetch during boot so by the time the customer clicks
      // an option, the face is already available.
      function warmFontKey(key) {
        var stack = FONT_STACKS[key];
        if (!stack || !document.fonts || !document.fonts.load) return Promise.resolve();
        // First quoted family in the stack is our web font; the rest are
        // OS fallbacks that don't need loading.
        var m = stack.match(/"([^"]+)"|'([^']+)'/);
        var fam = m ? (m[1] || m[2]) : null;
        if (!fam) return Promise.resolve();
        // Any size works — the browser caches by family+weight not size.
        return document.fonts.load('16px "' + fam + '"').catch(function () {});
      }
      var _pickerOpts = fontPickerEl.querySelectorAll('option[data-font-stack]');
      for (var _i = 0; _i < _pickerOpts.length; _i++) {
        warmFontKey(_pickerOpts[_i].getAttribute('data-font-stack'));
      }

      fontPickerEl.addEventListener('change', function () {
        CUSTOMER_FONT = fontPickerEl.value;
        updateFontProperty();
        // Belt-and-braces: even after the boot-time pre-warm, wait for
        // the browser to confirm the newly-picked face is ready before
        // rendering. Cheap when the font is already cached (resolves in
        // one microtask); prevents a fallback-face flash on slow
        // networks where boot pre-warm might not have finished yet.
        warmFontKey(CUSTOMER_FONT).then(function () {
          renderMultiFieldTexture();
          renderAll();
        });
      });
    }

    // ============================================================
    // Customer colour picker (mirrors the font picker)
    // ============================================================
    // When a template declares `content_schema.color_options`, the Liquid
    // renders a "Name colour" <select>. JS overrides each text field's
    // baked `color` at render time. No color_options => CUSTOMER_COLOR
    // stays null and getEffectiveColor(field) returns field.color.
    var colorPickerEl = root.querySelector('[data-mf-color-picker]');
    var colorPropEl   = root.querySelector('[data-mf-color-picker-property]');
    var CUSTOMER_COLOR = colorPickerEl ? colorPickerEl.value : null;

    function getEffectiveColor(field) {
      return CUSTOMER_COLOR || field.color || '#111111';
    }

    function updateColorProperty() {
      if (!colorPickerEl || !colorPropEl) return;
      var opt = colorPickerEl.options[colorPickerEl.selectedIndex];
      colorPropEl.value = opt ? (opt.textContent || opt.value) : '';
    }

    if (colorPickerEl) {
      updateColorProperty();
      colorPickerEl.addEventListener('change', function () {
        CUSTOMER_COLOR = colorPickerEl.value;
        updateColorProperty();
        renderMultiFieldTexture();
        renderAll();
      });
    }

    // Picker gate — keep the font/colour pickers hidden until the gated
    // field (e.g. "name") has content, so they only appear once there's
    // something to style. Rows opt in via data-mf-picker-gate="<fieldName>".
    var gateRows = root.querySelectorAll('[data-mf-picker-gate]');
    function updatePickerGate() {
      if (!gateRows.length) return;
      gateRows.forEach(function (row) {
        var fname = row.getAttribute('data-mf-picker-gate');
        var el = root.querySelector('[data-mf-input][data-mf-field-name="' + fname + '"]');
        var has = !!(el && el.value && el.value.trim().length);
        row.hidden = !has;
        var ctrl = row.querySelector('select');
        if (ctrl) ctrl.disabled = !has;
      });
    }
    updatePickerGate();

    // 2026-08-18 — call applyNameMesh() once at mount so any name
    // field pre-populated via `field.default` (e.g. Dog Portrait
    // shipping with default:"Bertie") triggers the with-name mesh /
    // design_scale / design_offset_y overrides on FIRST paint. Prior
    // to this, applyNameMesh only fired on 'input' events, which
    // meant the sample rendered at the base state (big Bertie) even
    // though the input already contained "Bertie" — override only
    // kicked in after the customer touched the field. Safe no-op on
    // templates without name_present_overrides.
    if (typeof applyNameMesh === 'function') applyNameMesh();

    // ============================================================
    // Design-swap engine
    // ============================================================
    // Multi-design templates (e.g. Daddy's Team) declare a
    // design_image_url_map keyed by a composite of certain content-
    // schema field values (design_swap_key_fields). When any of those
    // fields change, the wrap texture swaps to the matching PNG.
    //
    // Templates that DON'T use design swap emit an empty map, so
    // designKey/designUrlForCurrentKey degenerate to the primary
    // TPL.design_image_url — behaviour identical to before.
    var DESIGN_URL_MAP   = TPL.design_image_url_map || {};
    var DESIGN_KEY_FIELDS = TPL.design_swap_key_fields || [];

    // British Escapes range: a design LIST (more than the 4 legacy alt
    // slots) plus a slug->index map. Merge each mapped key's list URL into
    // DESIGN_URL_MAP so the single design field value resolves to its
    // artwork. Legacy templates emit an empty list/map and are unaffected.
    var DESIGN_LIST_URLS = TPL.design_list_urls || [];
    var DESIGN_SWAP_MAP  = TPL.design_swap_map || {};
    Object.keys(DESIGN_SWAP_MAP).forEach(function (k) {
      var idx = DESIGN_SWAP_MAP[k];
      if (DESIGN_LIST_URLS[idx] != null) DESIGN_URL_MAP[k] = DESIGN_LIST_URLS[idx];
    });

    // Read the currently-selected value for a content-schema field by
    // its `name`. Looks at the live DOM input rather than rebuilding
    // state, so this always reflects what the customer sees. Falls
    // back to the field's `default` if the input isn't in the DOM yet
    // (boot timing).
    function getFieldValueByName(name) {
      var el = root.querySelector(
        '[data-mf-input][data-mf-field-name="' + name + '"]'
      );
      if (el) return el.value;
      var fld = (TPL.fields || []).filter(function (f) {
        return f.name === name;
      })[0];
      return fld ? (fld.default || '') : '';
    }

    // Compose the design lookup key by joining the values of each
    // configured key field with "_" — e.g. ["colour", "kids"] with
    // values "blue" and "2" produces "blue_2".
    function computeDesignKey() {
      if (!DESIGN_KEY_FIELDS.length) return null;
      var parts = DESIGN_KEY_FIELDS.map(function (name) {
        return getFieldValueByName(name);
      });
      return parts.join('_');
    }

    // A runtime design (e.g. the customer's chosen Dog Portrait, set via
    // fbSetDesignImage) takes precedence over the metaobject's baked
    // design_image AND the keyed swap map — otherwise a name/colour change
    // that re-runs swapDesignImageIfNeeded() reverts to the placeholder
    // design. Null on every normal template, so behaviour is unchanged.
    var runtimeDesignUrl = null;
    function designUrlForCurrentKey() {
      if (runtimeDesignUrl) return runtimeDesignUrl;
      var key = computeDesignKey();
      if (key && DESIGN_URL_MAP[key]) return DESIGN_URL_MAP[key];
      return TPL.design_image_url;
    }

    // Pre-load the design image (drawn as the texture's base layer).
    // Initial URL is the design-swap match if applicable, else the
    // template's primary design_image_url.
    var designImage = new Image();
    var designReady = false;
    designImage.crossOrigin = 'anonymous';
    designImage.onload = function () {
      designReady = true;
      renderTextureMain();
      renderAll();
    };
    designImage.onerror = function () {
      console.warn('[fb-personaliser] design image failed to load:', designImage.src);
      designReady = false;
      // Don't trap the preview behind a permanent shimmer if a design 404s.
      if (root) root.classList.remove('fb-loading');
      signalReady();
    };
    designImage.src = designUrlForCurrentKey();

    // Swap the wrap texture to the URL matching the current design key.
    // No-op when the URL is already loaded — avoids needless re-renders
    // when a non-key field changes. Triggers a re-render once the new
    // image has decoded (onload fires).
    function swapDesignImageIfNeeded() {
      var url = designUrlForCurrentKey();
      if (!url || url === designImage.src) return;
      // Load the newly-picked design in a SEPARATE image so the current one
      // stays on screen until the new one has decoded — no blank flash on
      // swap. designReady stays true throughout, so the synchronous
      // re-render that follows this call keeps drawing the old design (plus
      // any live text change). We swap the new image in only once it's ready.
      var loader = new Image();
      loader.crossOrigin = 'anonymous';
      loader.onload = function () {
        designImage = loader;
        designReady = true;
        renderTextureMain();
        renderAll();
      };
      loader.onerror = function () {
        console.warn('[fb-personaliser] design image failed to load:', url);
      };
      loader.src = url;
    }

    // Set the design image from an ARBITRARY runtime URL. Used by the
    // self-serve Dog Portrait product, which feeds the customer's CHOSEN
    // AI-generated portrait in at pick-time — there is no pre-baked design
    // slot to swap to, so the keyed swapDesignImageIfNeeded() path above
    // can't reach it. Additive + backwards-compatible: no existing template
    // calls this, and the keyed swap path is untouched. Background-loads
    // like the swap (no blank flash), then re-renders both sides + all
    // views. Same-side duplication is automatic via SHARED.repeat_x.
    function fbSetDesignImage(url) {
      if (!url || url === designImage.src) return;
      // Remember this as the source of truth so any later re-render (name
      // typing, colour swatch) keeps the chosen portrait rather than
      // reverting to the metaobject's placeholder design.
      runtimeDesignUrl = url;
      if (root) root.classList.add('fb-loading');
      var loader = new Image();
      loader.crossOrigin = 'anonymous';
      loader.onload = function () {
        designImage = loader;
        designReady = true;
        renderTextureMain();
        renderAll();
      };
      loader.onerror = function () {
        console.warn('[fb-personaliser] runtime design image failed to load:', url);
        if (root) root.classList.remove('fb-loading');
      };
      loader.src = url;
    }
    // Expose to the storefront intake (Dog Portrait) two ways: a direct
    // global and a DOM-event bridge, so callers don't depend on script
    // load order. Harmless on every other template (never invoked).
    try {
      window.fbSetDesignImage = fbSetDesignImage;
      document.addEventListener('fb-personaliser:set-design', function (e) {
        var url = e && e.detail && e.detail.url;
        if (url) fbSetDesignImage(url);
      });
    } catch (err) { /* non-browser context — ignore */ }

    function sanitize(value) {
      return (value || '').toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, MAX);
    }

    // Brightness/saturation tweak applied only to the design layer
    // (not customer text). Bring this down to soften an overly-bright
    // design relative to the mug body's ambient lighting, or up to lift a
    // flat one. The brightness multiplier is driven by
    // SHARED.overlay_brightness (template metaobject `overlay_brightness`,
    // default 0.95) so it's tunable per template and live via the
    // ?fb_calibrate=1 panel. Computed fresh on each draw so slider changes
    // take effect on the next renderTextureMain().
    function designFilter() {
      var b = (SHARED.overlay_brightness != null) ? SHARED.overlay_brightness : 0.95;
      return 'brightness(' + b + ') saturate(0.98)';
    }

    // ============================================================
    // Render dispatch — picks single-text or multi-field per template.
    // ============================================================
    function renderTextureMain() {
      if (IS_MF) {
        renderMultiFieldTexture();
      } else if (input) {
        renderTexture(sanitize(input.value));
      }
    }

    // ============================================================
    // Multi-field rendering
    // ============================================================
    // Two-stage:
    //   1. Render ONE clean instance (design + fields) to singleSideCanvas.
    //      This is what the customer's flat preview shows.
    //   2. Tile singleSideCanvas across textureCanvas `repeat_x` times.
    //      That's what the cylinder uses, so the design appears on
    //      multiple sides of the mug (front + back for repeat_x = 2).
    // Draw the design image onto the texture with optional independent
    // scale + vertical offset (SHARED.design_scale / design_offset_y).
    // Defaults (1 / 0) reproduce the original full-canvas drawImage exactly,
    // so legacy templates are unaffected. Used to shrink + drop the artwork
    // (e.g. when a name is present) WITHOUT touching the name layer, which is
    // drawn separately at its own anchor_y. Scales about the canvas centre;
    // offset is a fraction of canvas height (positive = down).
    function drawDesignScaled(ctx, w, h) {
      var s  = (SHARED.design_scale    != null) ? SHARED.design_scale    : 1;
      var oy = (SHARED.design_offset_y != null) ? SHARED.design_offset_y : 0;
      if (s === 1 && oy === 0) { ctx.drawImage(designImage, 0, 0, w, h); return; }
      var dw = w * s, dh = h * s;
      var dx = (w - dw) / 2;
      var dy = (h - dh) / 2 + oy * h;
      ctx.drawImage(designImage, dx, dy, dw, dh);
    }

    function renderMultiFieldTexture() {
      var w = singleSideCanvas.width;
      var h = singleSideCanvas.height;

      // ---- Stage 1: render single-side composite ----
      // Layer order matters for image-field templates:
      //   1. Photos drawn at hole positions (clipped to each hole)
      //   2. Design overlay on top — its opaque polaroid frames mask
      //      photo edges; its transparent holes let photos show through
      //   3. Text/select fields drawn last (on top of design, like before)
      // For text/select-only templates (numberplates, seventies) the
      // photo loop is a no-op and behaviour is identical to before.
      ssCtx.clearRect(0, 0, w, h);

      // 1. Photo layer (image fields only). Sort by z_order ascending
      //    so back-most photos draw first, foreground ones last. Lets
      //    overlapping polaroid frames stack as the design intends —
      //    e.g. best-dad-ever's order is z=1 (Photo 3, back) through
      //    z=5 (Photo 1, top).
      var imageFields = (TPL.fields || []).filter(function (f) {
        return f.type === 'image';
      });
      imageFields.sort(function (a, b) {
        return (a.z_order || 0) - (b.z_order || 0);
      });
      imageFields.forEach(function (field) {
        renderMfImageOnCanvas(ssCtx, field, w, h);
      });

      // 2. Design overlay
      if (designReady) {
        ssCtx.save();
        ssCtx.filter = designFilter();
        drawDesignScaled(ssCtx, w, h);
        ssCtx.restore();
      }

      // 3. Text/select fields (rendered on top of the design)
      (TPL.fields || []).forEach(function (field) {
        if (field.type === 'image') return;
        // design_key_part selects are pure design-swap drivers; they
        // don't render any text/overlay onto the canvas.
        if (field.design_key_part) return;
        // Hidden by show_when — skip entirely, no overlay drawn.
        if (!isFieldVisible(field)) return;
        // Apply any overrides_by/overrides merge (e.g. shirt anchors
        // shifted per Kids count). After this `field` carries the
        // effective config for the current state.
        var eff   = getEffectiveField(field);
        var value = getMfFieldRenderValue(eff);
        if (!value) return;
        // Multi-anchor support: when a field declares an `anchors`
        // array, render the same text at every anchor (useful when
        // the PNG already contains multiple wrap halves and the
        // same name needs to appear at multiple positions).
        var anchors = eff.anchors;
        if (anchors && anchors.length) {
          anchors.forEach(function (a) {
            var perAnchor = Object.assign({}, eff, {
              anchor_x: a.anchor_x,
              anchor_y: a.anchor_y,
            });
            renderMfFieldOnCanvas(ssCtx, perAnchor, value, w, h);
          });
        } else {
          renderMfFieldOnCanvas(ssCtx, eff, value, w, h);
        }
      });

      // ---- Stage 2: tile single-side onto texture canvas ----
      // Instances tile sequentially from the canvas left edge. Per the
      // seventies design intent: centre view shows the "between" area
      // where the two instances' edge stripes meet (no text on the
      // mug's centre face); left/right views surface a full instance.
      var repeats = Math.max(1, Math.round(SHARED.repeat_x || 1));
      var tw = textureCanvas.width;
      var th = textureCanvas.height;
      tctx.clearRect(0, 0, tw, th);
      for (var i = 0; i < repeats; i++) {
        tctx.drawImage(singleSideCanvas, i * w, 0, w, h);
      }
    }

    // Composite a customer-uploaded photo into its polaroid hole.
    // Renders nothing if the photo hasn't been uploaded yet — the design
    // overlay drawn in step 2 will hide the empty area behind its
    // (currently transparent) hole, so the customer sees the bare mug
    // showing through and understands they need to upload.
    //
    // Cover-fit: scale photo so it covers the hole exactly, cropping
    // any overflow. Customer photos are usually rectangular, holes are
    // square, so cover-fit avoids letterboxing while keeping the photo
    // recognisable.
    function renderMfImageOnCanvas(ctx, field, w, h) {
      var img = photoImages[field.property_name];
      if (!img) return;

      var anchorX = (field.anchor_x != null ? field.anchor_x : 0.5) * w;
      var anchorY = (field.anchor_y != null ? field.anchor_y : 0.5) * h;
      var holeW   = (field.width_frac  != null ? field.width_frac  : 0.5) * w;
      var holeH   = (field.height_frac != null ? field.height_frac : 0.5) * h;
      var rotRad  = (field.rotation || 0) * Math.PI / 180;

      ctx.save();
      ctx.translate(anchorX, anchorY);
      if (rotRad) ctx.rotate(rotRad);

      // Clip to hole bounds — stops a photo bleeding into adjacent
      // holes if it ends up oversized due to calibration values.
      ctx.beginPath();
      ctx.rect(-holeW / 2, -holeH / 2, holeW, holeH);
      ctx.clip();

      // Cover fit
      var imgAspect  = img.width / img.height;
      var holeAspect = holeW / holeH;
      var sw, sh;
      if (imgAspect > holeAspect) {
        // Image is wider than hole — crop the sides
        sh = img.height;
        sw = sh * holeAspect;
      } else {
        // Image is taller than hole — crop top/bottom
        sw = img.width;
        sh = sw / holeAspect;
      }

      // Customer-controlled crop offset. offset.x and offset.y are each
      // in [-1, 1]:
      //   0  = centred (default)
      //   +1 = pan to the right edge of the source (show right-most portion)
      //   -1 = pan to the left edge of the source (show left-most portion)
      // Same convention for vertical.
      var offset    = photoOffsets[field.property_name] || { x: 0, y: 0 };
      var center_sx = (img.width  - sw) / 2;
      var center_sy = (img.height - sh) / 2;
      var sx = center_sx * (1 + (offset.x || 0));
      var sy = center_sy * (1 + (offset.y || 0));
      // Clamp so the crop window never extends past the image bounds.
      sx = Math.max(0, Math.min(img.width  - sw, sx));
      sy = Math.max(0, Math.min(img.height - sh, sy));

      ctx.drawImage(img, sx, sy, sw, sh, -holeW / 2, -holeH / 2, holeW, holeH);

      ctx.restore();
    }

    // Resolve {token_name} placeholders inside a string, using the
    // current values of any token inputs declared by `option`.
    function resolveMfTokens(option, fieldName, str) {
      if (!option.tokens || !str) return str;
      var out = str;
      option.tokens.forEach(function (token) {
        var ti = root.querySelector(
          '[data-mf-token][data-mf-token-field="' + fieldName + '"]' +
          '[data-mf-token-name="' + token.name + '"]'
        );
        var tv = ti ? ti.value : token.default;
        // Support both [name] (display label syntax) and {name} (segment syntax)
        out = out.split('[' + token.name + ']').join(tv);
        out = out.split('{' + token.name + '}').join(tv);
      });
      return out;
    }

    // Build the renderable value for one field — either a single text
    // string or an array of segments with their own colours.
    // Compose a text field's rendered/stored string from the customer's
    // raw input plus optional static prefix/suffix declared on the field
    // (e.g. suffix "'s Kitchen" turns "Sarah" into "Sarah's Kitchen").
    // Used for name-LED designs where the personalised line IS the saying.
    // Empty input stays empty (so `required` validation still fires and we
    // never render a stray "'s Kitchen"); fields with no prefix/suffix are
    // returned unchanged, so every existing template is unaffected.
    function composeMfText(field, raw) {
      raw = (raw == null ? '' : String(raw)).trim();
      if (!raw) return raw;
      if (field.prefix || field.suffix) {
        return (field.prefix || '') + raw + (field.suffix || '');
      }
      return raw;
    }

    function getMfFieldRenderValue(field) {
      if (field.type === 'text') {
        var inp = root.querySelector(
          '[data-mf-input][data-mf-field-name="' + field.name + '"]'
        );
        var raw = inp ? inp.value : (field.default || '');
        return { text: composeMfText(field, raw) };
      }
      if (field.type === 'select') {
        var sel = root.querySelector(
          '[data-mf-input][data-mf-field-name="' + field.name + '"]'
        );
        var optVal = sel ? sel.value : field.default;
        var opt = (field.options || []).filter(function (o) {
          return o.value === optVal;
        })[0];
        if (!opt) return null;

        if (opt.segments) {
          return {
            segments: opt.segments.map(function (seg) {
              return {
                text:      resolveMfTokens(opt, field.name, seg.text),
                color:     seg.color,
                // Preserve layout attributes so multi-line rendering works.
                line:      seg.line,
                size_mult: seg.size_mult,
              };
            }),
          };
        }
        return { text: resolveMfTokens(opt, field.name, opt.label) };
      }
      return null;
    }

    // Composite one field's value onto the given context, centred
    // horizontally at canvas mid-width and at the field's anchor_y.
    //
    // Segments can opt into multi-line layout via `line` (1, 2, ...)
    // and per-segment `size_mult`. All segments on the same line share
    // the line's font size = base × max(size_mult on that line). Lines
    // stack vertically around the field's anchor.
    function renderMfFieldOnCanvas(ctx, field, value, w, h) {
      var anchorY      = (field.anchor_y != null ? field.anchor_y : 0.5) * h;
      // anchor_x defaults to 0.5 (canvas mid-width) so existing templates
      // without an anchor_x stay centred — matches prior behaviour.
      // Templates that lay out multiple horizontal positions (e.g.
      // Daddy's Team with named shirts at different x) set anchor_x
      // per-anchor, with `anchors` arrays driving multi-anchor render.
      var anchorX      = (field.anchor_x != null ? field.anchor_x : 0.5) * w;
      // Font resolution: customer's font picker (if any) wins; falls
      // back to the field's baked font, then to charles-wright. The
      // getEffectiveFont() helper handles the priority chain.
      var fontStack    = FONT_STACKS[getEffectiveFont(field)] || FONT_STACKS['charles-wright'];
      var color        = getEffectiveColor(field);
      var maxWidthFrac = field.max_width_frac != null ? field.max_width_frac : 0.95;
      var maxWidth     = w * maxWidthFrac;

      var totalText = value.segments
        ? value.segments.map(function (s) { return s.text; }).join(' ')
        : (value.text || '');
      if (!totalText) return;

      var cap = capForLength(field.size_caps, totalText.length, field.size_fallback || 50);
      var baseSize = (cap / 100) * h;

      ctx.textBaseline = 'middle';

      if (!value.segments) {
        // ---- Single colour, single line ----
        ctx.font = '400 ' + baseSize + 'px ' + fontStack;
        var measured = ctx.measureText(value.text).width;
        if (measured > maxWidth) {
          baseSize = baseSize * (maxWidth / measured);
          ctx.font = '400 ' + baseSize + 'px ' + fontStack;
          measured = ctx.measureText(value.text).width;
        }
        ctx.textAlign = 'center';
        ctx.fillStyle = color;
        ctx.fillText(value.text, anchorX, anchorY);
        if (field.decoration === 'underline') {
          var underlineH0 = Math.max(2, baseSize * 0.04);
          var underlineY0 = anchorY + baseSize * 0.42;
          ctx.fillRect(anchorX - measured / 2, underlineY0, measured, underlineH0);
        }
        return;
      }

      // ---- Multi-line, multi-colour segments ----
      // Group segments by line (default line = 1).
      var segByLine = {};
      value.segments.forEach(function (seg) {
        var ln = seg.line || 1;
        if (!segByLine[ln]) segByLine[ln] = [];
        segByLine[ln].push(seg);
      });
      var lineNums = Object.keys(segByLine).map(Number).sort(function (a, b) { return a - b; });

      // Per-line font size = base × max segment size_mult on that line.
      // Width of a line measured with each segment at its own font size.
      function lineFontSize(line, base) {
        var maxMult = 1;
        line.forEach(function (s) {
          var m = (s.size_mult != null ? s.size_mult : 1);
          if (m > maxMult) maxMult = m;
        });
        return base * maxMult;
      }
      function measureLineWidth(line, base) {
        var fs = lineFontSize(line, base);
        ctx.font = '400 ' + fs + 'px ' + fontStack;
        var spaceW = ctx.measureText(' ').width;
        var w = 0;
        line.forEach(function (s, i) {
          w += ctx.measureText(s.text).width;
          if (i < line.length - 1) w += spaceW;
        });
        return w;
      }

      // Find the widest line at the base size, scale base down if it
      // exceeds max width.
      var widest = 0;
      lineNums.forEach(function (ln) {
        var lw = measureLineWidth(segByLine[ln], baseSize);
        if (lw > widest) widest = lw;
      });
      if (widest > maxWidth) {
        baseSize *= maxWidth / widest;
      }

      // Lay lines out vertically around anchor_y. Each line takes its
      // own font size of vertical space; total block height is the sum.
      var lineSizes = lineNums.map(function (ln) {
        return lineFontSize(segByLine[ln], baseSize);
      });
      var blockH = lineSizes.reduce(function (a, b) { return a + b; }, 0);

      var cursorY = anchorY - blockH / 2;
      lineNums.forEach(function (ln, idx) {
        var line   = segByLine[ln];
        var lineFs = lineSizes[idx];
        var lineY  = cursorY + lineFs / 2;
        cursorY += lineFs;

        ctx.font = '400 ' + lineFs + 'px ' + fontStack;
        var spaceW = ctx.measureText(' ').width;
        // Pre-measure full line so we can centre-anchor it.
        var widths = line.map(function (s) { return ctx.measureText(s.text).width; });
        var lineW  = widths.reduce(function (a, b) { return a + b; }, 0)
                   + spaceW * (line.length - 1);

        ctx.textAlign = 'left';
        var x = anchorX - lineW / 2;
        var lineStartX = x;
        line.forEach(function (seg, i) {
          ctx.fillStyle = seg.color;
          ctx.fillText(seg.text, x, lineY);
          x += widths[i] + (i < line.length - 1 ? spaceW : 0);
        });

        if (field.decoration === 'underline') {
          var ulH = Math.max(2, lineFs * 0.04);
          var ulY = lineY + lineFs * 0.42;
          ctx.fillStyle = color;
          ctx.fillRect(lineStartX, ulY, lineW, ulH);
        }
      });
    }

    // ============================================================
    // Conditional fields (show_when) + per-value overrides (overrides_by)
    // ============================================================
    // Two complementary mechanisms a template can opt into:
    //
    //   - show_when: { fieldname: "value" }
    //       Hides the entire field row AND disables its input when the
    //       controller field's value doesn't match. Used for fields
    //       that should only collect input under certain choices
    //       (e.g. Kid 2 name/number only when Kids = 2).
    //
    //   - overrides_by + overrides: { value: { ...partial config } }
    //       Merges a partial field config on top of the base when the
    //       controller field has a specific value. Lets one field
    //       carry different anchor positions per layout without
    //       duplicating the whole field declaration.

    // Evaluate a field's show_when rule against current input values.
    // Multiple keys in show_when must all match (AND). A value can be
    // a string (exact match) or an array (any-of match).
    function isFieldVisible(field) {
      var rule = field.show_when;
      if (!rule) return true;
      for (var key in rule) {
        if (!rule.hasOwnProperty(key)) continue;
        var expected = rule[key];
        var actual   = getFieldValueByName(key);
        if (Array.isArray(expected)) {
          if (expected.indexOf(actual) === -1) return false;
        } else if (actual !== expected) {
          return false;
        }
      }
      return true;
    }

    // Return field config with any matching overrides_by entry merged
    // on top. Shallow merge — keys in the override block replace
    // top-level field keys outright (anchors array replaces, not
    // merges, which matches expectations for typical use).
    function getEffectiveField(field) {
      if (!field.overrides_by || !field.overrides) return field;
      var controllerValue = getFieldValueByName(field.overrides_by);
      var override = field.overrides[controllerValue];
      if (!override) return field;
      var merged = {};
      for (var k in field) if (field.hasOwnProperty(k)) merged[k] = field[k];
      for (var k2 in override) if (override.hasOwnProperty(k2)) merged[k2] = override[k2];
      return merged;
    }

    // Apply show_when rules to the rendered DOM:
    //   - rows with `data-mf-show-when` get `hidden` toggled to match
    //     the rule's current evaluation
    //   - their input(s) get `disabled` toggled to match — disabled
    //     inputs are skipped by HTML form submission, so hidden Kid 2
    //     name/number never reach Shopify's order properties when the
    //     customer picks 1 child.
    // No-op for templates that don't declare any show_when.
    function updateMfFieldVisibility() {
      var rows = root.querySelectorAll('[data-mf-field-row][data-mf-show-when]');
      rows.forEach(function (row) {
        var fieldName = row.getAttribute('data-mf-field-name');
        var field = (TPL.fields || []).filter(function (f) {
          return f.name === fieldName;
        })[0];
        if (!field) return;
        var visible = isFieldVisible(field);
        row.hidden = !visible;
        // Disable any input(s) inside the row when hidden — the form
        // won't submit disabled controls, so the hidden values stay
        // out of the customer's order properties.
        var inputs = row.querySelectorAll('input, select, textarea');
        inputs.forEach(function (inp) { inp.disabled = !visible; });
      });
    }

    // Show only the token group for the currently-selected option of
    // each select field.
    function updateMfTokenVisibility() {
      (TPL.fields || []).forEach(function (field) {
        if (field.type !== 'select') return;
        var sel = root.querySelector(
          '[data-mf-input][data-mf-field-name="' + field.name + '"]'
        );
        if (!sel) return;
        var current = sel.value;
        var groups = root.querySelectorAll(
          '[data-mf-tokens-for-field="' + field.name + '"]'
        );
        groups.forEach(function (g) {
          g.hidden = g.getAttribute('data-mf-tokens-for-option') !== current;
        });
      });
    }

    // Keep the hidden `properties[X]` input in sync with the select +
    // tokens, so Shopify's order receives the resolved human-readable
    // string (e.g. "Groovy since 1980") not the slug.
    function updateMfPropertyInputs() {
      (TPL.fields || []).forEach(function (field) {
        // Text fields with a prefix/suffix submit a COMPOSED string
        // (e.g. "Sarah's Kitchen") via a hidden mirror input — the same
        // pattern select uses. Plain text fields keep name= on their
        // visible input and are submitted by the browser directly, so
        // they're skipped here (unchanged behaviour).
        if (field.type === 'text') {
          if (!field.prefix && !field.suffix) return;
          var tinp = root.querySelector(
            '[data-mf-input][data-mf-field-name="' + field.name + '"]'
          );
          var thidden = root.querySelector(
            '[data-mf-property][data-mf-field-name="' + field.name + '"]'
          );
          if (!tinp || !thidden) return;
          thidden.value = composeMfText(field, tinp.value);
          return;
        }
        if (field.type !== 'select') return;
        var sel = root.querySelector(
          '[data-mf-input][data-mf-field-name="' + field.name + '"]'
        );
        var hidden = root.querySelector(
          '[data-mf-property][data-mf-field-name="' + field.name + '"]'
        );
        if (!sel || !hidden) return;
        var optVal = sel.value;
        var opt = (field.options || []).filter(function (o) {
          return o.value === optVal;
        })[0];
        if (!opt) return;
        hidden.value = resolveMfTokens(opt, field.name, opt.label || '');
      });
    }

    function renderTexture(text) {
      var w = textureCanvas.width;
      var h = textureCanvas.height;
      tctx.clearRect(0, 0, w, h);

      // Layer 1 — design image (e.g. yellow plate with FLIPPING BANGERS)
      if (designReady) {
        tctx.save();
        tctx.filter = designFilter();
        tctx.drawImage(designImage, 0, 0, w, h);
        tctx.restore();
      }

      // Layer 2 — customer text (rendered on offscreen canvas so we can
      // weather it independently of the design layer).
      if (text) {
        var cap = maxSizeFor(text.length);
        var fontSize = (cap / 100) * h;

        textCtx.clearRect(0, 0, w, h);
        textCtx.textAlign = 'center';
        textCtx.textBaseline = 'middle';
        textCtx.font = '400 ' + fontSize + 'px ' + FONT_FAMILY;

        // Auto-scale to fit the canvas width (within 95%)
        var usableWidth = w * 0.95;
        var measured = textCtx.measureText(text).width;
        if (measured > usableWidth) {
          fontSize = fontSize * (usableWidth / measured);
          textCtx.font = '400 ' + fontSize + 'px ' + FONT_FAMILY;
          measured   = usableWidth;
        }

        var yOffset = SHARED.text_vertical * h;
        var tx = w / 2;
        var ty = h / 2 + yOffset;

        // Thickness — render as a stroke BEHIND the fill so glyphs stay
        // sharp at their original shape but with a thicker outline.
        // THICKNESS slider value (0–50) maps to 0–0.05em line width.
        if (THICKNESS > 0) {
          textCtx.strokeStyle = TEXT_COLOR;
          textCtx.lineWidth   = (THICKNESS / 1000) * fontSize * 2;
          textCtx.lineJoin    = 'round';
          textCtx.miterLimit  = 2;
          textCtx.strokeText(text, tx, ty);
        }

        textCtx.fillStyle = TEXT_COLOR;
        textCtx.fillText(text, tx, ty);

        // Weathering — chip pixels out of the text canvas so the dark plate
        // shows through where the "paint" has worn away. Bounded to the
        // text bounding box so noise doesn't hit the rest of the canvas
        // (no-op anyway since destination-out only affects opaque pixels,
        // but cheaper).
        if (WEATHERING > 0) {
          var halfW = measured / 2 + (THICKNESS > 0 ? textCtx.lineWidth : 0);
          var halfH = fontSize * 0.7;  // taller than glyph height to catch ascenders
          var bx = Math.max(0, tx - halfW);
          var by = Math.max(0, ty - halfH);
          var bw = Math.min(w - bx, halfW * 2);
          var bh = Math.min(h - by, halfH * 2);
          // Seed from text content so different inputs land different
          // patterns, but the same input is consistent across renders.
          var seed = 0;
          for (var ci = 0; ci < text.length; ci++) seed = (seed * 31 + text.charCodeAt(ci)) | 0;
          applyWeathering(textCtx, bx, by, bw, bh, WEATHERING, seed || 1);
        }

        // Composite the (optionally weathered) text onto the texture canvas
        tctx.drawImage(textCanvas, 0, 0);
      }
    }

    // ============================================================
    // Three.js
    // ============================================================
    var threeReady = false;
    var scene, camera, mesh, texture;

    function loadThree(cb) {
      if (window.THREE) { cb(); return; }
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js';
      s.crossOrigin = 'anonymous';
      s.onload = cb;
      s.onerror = function () { console.error('[fb-personaliser] three.js failed to load'); };
      document.head.appendChild(s);
    }

    function buildGeometry() {
      var THREE = window.THREE;
      var radiusTop    = 1;
      // Bottom radius as a fraction of top — default 1 (straight cylinder).
      // <1 narrows the base (flared mug body); >1 inverts. Used for mug
      // shapes whose silhouette tapers (latte cup widens toward the rim).
      var rBotFrac     = SHARED.radius_bottom != null ? SHARED.radius_bottom : 1;
      var radiusBottom = radiusTop * rBotFrac;
      // Effective aspect = design × repeat_x. The texture canvas tiles
      // singleSideCanvas N times, so the wrapped cylinder needs to match
      // that wider effective texture. Use the AVERAGE radius for the
      // height calc so a tapered cylinder still wraps the design at
      // correct overall proportions (text/stripes won't look right at
      // the very top or very bottom edges, but the bulk of the design
      // tracks the design's intrinsic aspect).
      var avgRadius = (radiusTop + radiusBottom) / 2;
      var effAspect = SHARED.design_aspect * (SHARED.repeat_x || 1);
      var height = (2 * Math.PI * avgRadius * SHARED.wrap_fraction) / effAspect;
      var thetaLength = 2 * Math.PI * SHARED.wrap_fraction;
      return new THREE.CylinderGeometry(
        radiusTop, radiusBottom, height,
        96, 1, true, 0, thetaLength
      );
    }

    function applyClipForView(v) {
      // Apply a clip to the hero canvas (and matching thumb) so only the
      // mug-body silhouette area shows. Two render paths:
      //   - softness == 0:  CSS clip-path polygon (cheap, hard edges)
      //   - softness  > 0:  CSS mask-image with an inline SVG that runs the
      //                     polygon through feGaussianBlur, giving feathered
      //                     edges that fade smoothly into the mug photo.
      // The bottom corners can slant inward (or outward) relative to the
      // top corners so the mask traces a trapezoid that follows the mug's
      // natural taper, instead of a perfectly axis-aligned rectangle.
      var blX = v.clipLeft  + (v.clipLeftSlant  || 0);
      var brX = v.clipRight - (v.clipRightSlant || 0);
      var softness = SHARED.edge_softness || 0;

      function setClipPath(el, poly) {
        if (!el) return;
        el.style.maskImage = '';
        el.style.webkitMaskImage = '';
        el.style.clipPath = poly;
      }
      function setMaskImage(el, url) {
        if (!el) return;
        el.style.clipPath = '';
        el.style.maskImage = url;
        el.style.webkitMaskImage = url;
        el.style.maskSize = '100% 100%';
        el.style.webkitMaskSize = '100% 100%';
        el.style.maskRepeat = 'no-repeat';
        el.style.webkitMaskRepeat = 'no-repeat';
      }

      if (softness <= 0) {
        var poly = 'polygon(' +
          v.clipLeft  + '% ' + v.clipTop    + '%, ' +
          v.clipRight + '% ' + v.clipTop    + '%, ' +
          brX         + '% ' + v.clipBottom + '%, ' +
          blX         + '% ' + v.clipBottom + '%)';
        setClipPath(v.canvas, poly);
        setClipPath(v.thumbCanvas, poly);
        // Clone canvases (the duplicate thumb strip in the bottom-ATC area
        // for full-width-template products) need the same clip — without
        // it the rendered design extends past the mug-body silhouette,
        // visibly mismatching the gallery thumbs above.
        setClipPath(v.cloneCanvas, poly);
        return;
      }

      // Soft mask path — generate an inline SVG with the polygon blurred
      // along its alpha. preserveAspectRatio="none" stretches the 0-100
      // viewBox to fit the canvas exactly, so the % positions still match.
      var pts =
        v.clipLeft  + ',' + v.clipTop    + ' ' +
        v.clipRight + ',' + v.clipTop    + ' ' +
        brX         + ',' + v.clipBottom + ' ' +
        blX         + ',' + v.clipBottom;
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">' +
          '<filter id="b" x="-20%" y="-20%" width="140%" height="140%">' +
            '<feGaussianBlur stdDeviation="' + softness + '"/>' +
          '</filter>' +
          '<polygon points="' + pts + '" fill="white" filter="url(#b)"/>' +
        '</svg>';
      var url = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
      setMaskImage(v.canvas, url);
      setMaskImage(v.thumbCanvas, url);
      // Clone canvases need the same soft mask — see comment in the
      // hard-clip path above.
      setMaskImage(v.cloneCanvas, url);
    }

    // Force-recreate the CanvasTexture from textureCanvas. Needed when
    // textureCanvas dimensions change (design_aspect / repeat_x), because
    // Three.js's CanvasTexture upload path doesn't always handle source-
    // canvas resizes cleanly — without a fresh texture, the GPU binding
    // can show ghost vertical tiling of old content. Cheap to recreate;
    // we just re-bind the new texture to the existing material.
    function rebuildTexture() {
      if (!threeReady) return;
      var THREE = window.THREE;
      if (texture) texture.dispose();
      texture = new THREE.CanvasTexture(textureCanvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = 8;
      if (mesh && mesh.material) {
        mesh.material.map = texture;
        mesh.material.needsUpdate = true;
      }
    }

    // Apply current SHARED values to the Three.js camera + mesh. Used by
    // the calibration panel (live-tune) AND the size watcher (mug shape
    // change). `rebuildGeometry: true` rebuilds the cylinder geometry —
    // needed when design_aspect or wrap_fraction changed.
    function applySharedToScene(rebuildGeometry) {
      if (!threeReady) return;
      camera.fov = SHARED.camera_fov;
      camera.position.z = SHARED.camera_distance;
      camera.updateProjectionMatrix();
      if (rebuildGeometry) {
        var oldGeom = mesh.geometry;
        mesh.geometry = buildGeometry();
        if (oldGeom) oldGeom.dispose();
      }
      mesh.rotation.x = SHARED.mesh_tilt;
      mesh.rotation.z = SHARED.mesh_roll || 0;
      mesh.position.set(SHARED.mesh_x, SHARED.mesh_y, 0);
      // mesh_scale_y is a Y-only multiplier on top of the uniform
      // mesh_scale. Default 1 = uniform (legacy behaviour). <1 squishes
      // the cylinder vertically without affecting radius — useful when
      // the design's natural aspect is taller than the mug body.
      var msY = SHARED.mesh_scale_y != null ? SHARED.mesh_scale_y : 1;
      mesh.scale.set(SHARED.mesh_scale, SHARED.mesh_scale * msY, SHARED.mesh_scale);
    }

    function initThree() {
      var THREE = window.THREE;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(SHARED.camera_fov, 1, 0.1, 100);
      camera.position.set(0, 0, SHARED.camera_distance);
      camera.lookAt(0, 0, 0);

      texture = new THREE.CanvasTexture(textureCanvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = 8;

      var material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
        side: THREE.FrontSide,
      });
      mesh = new THREE.Mesh(buildGeometry(), material);
      mesh.rotation.x = SHARED.mesh_tilt;
      mesh.rotation.z = SHARED.mesh_roll || 0;
      mesh.position.set(SHARED.mesh_x, SHARED.mesh_y, 0);
      // Apply mesh_scale_y Y-only multiplier on initial mount so first
      // paint respects the metaobject value (otherwise mesh_scale_y only
      // took effect after the first slider/config update).
      var initMsY = SHARED.mesh_scale_y != null ? SHARED.mesh_scale_y : 1;
      mesh.scale.set(SHARED.mesh_scale, SHARED.mesh_scale * initMsY, SHARED.mesh_scale);
      scene.add(mesh);

      // Find canvases in the gallery (document-wide — not scoped to root,
      // since the canvases live in sp-gallery, not the personaliser block).
      // Also pick up the duplicate "thumb clone" canvases inside the
      // full-width-template bottom area — these mirror the gallery thumbs
      // so customers see the live design without scrolling back up.
      VIEWS.forEach(function (v) {
        v.canvas       = document.querySelector('[data-fb-canvas][data-fb-view="' + v.id + '"]');
        v.thumbCanvas  = document.querySelector('[data-fb-canvas-thumb][data-fb-view="' + v.id + '"]');
        v.cloneCanvas  = document.querySelector('[data-fb-canvas-thumb-clone][data-fb-view="' + v.id + '"]');
        v.heroPane     = document.querySelector('[data-fb-hero-pane="' + v.id + '"]');
        if (!v.canvas) {
          console.warn('[fb-personaliser] missing hero canvas for view:', v.id);
          return;
        }
        v.renderer = new THREE.WebGLRenderer({
          canvas: v.canvas, alpha: true, antialias: true,
          preserveDrawingBuffer: true,  // needed so we can drawImage to thumb
        });
        v.renderer.setPixelRatio(window.devicePixelRatio || 1);
        v.renderer.setClearColor(0x000000, 0);
        if (v.thumbCanvas) {
          v.thumbCtx = v.thumbCanvas.getContext('2d');
        }
        if (v.cloneCanvas) {
          v.cloneCtx = v.cloneCanvas.getContext('2d');
        }
        applyClipForView(v);
      });

      threeReady = true;
      resizeAll();
      renderAll();
    }

    function resizeAll() {
      if (!threeReady) return;
      VIEWS.forEach(function (v) {
        if (!v.heroPane || !v.renderer) return;
        var w = v.heroPane.clientWidth, h = v.heroPane.clientHeight;
        if (w === 0 || h === 0) return;
        v.renderer.setSize(w, h, false);
        var dpr = window.devicePixelRatio || 1;
        // Match the thumb canvas backing-store size to its display size
        if (v.thumbCanvas) {
          var tw = v.thumbCanvas.clientWidth || v.thumbCanvas.parentElement.clientWidth;
          var th = v.thumbCanvas.clientHeight || v.thumbCanvas.parentElement.clientHeight;
          if (tw > 0 && th > 0) {
            v.thumbCanvas.width  = Math.round(tw * dpr);
            v.thumbCanvas.height = Math.round(th * dpr);
          }
        }
        // Same for the duplicate "clone" thumbs in the bottom area.
        if (v.cloneCanvas) {
          var cw = v.cloneCanvas.clientWidth || v.cloneCanvas.parentElement.clientWidth;
          var ch = v.cloneCanvas.clientHeight || v.cloneCanvas.parentElement.clientHeight;
          if (cw > 0 && ch > 0) {
            v.cloneCanvas.width  = Math.round(cw * dpr);
            v.cloneCanvas.height = Math.round(ch * dpr);
          }
        }
      });
      var first = VIEWS.find(function (v) { return v.heroPane && v.heroPane.clientWidth > 0; });
      if (first) {
        camera.aspect = first.heroPane.clientWidth / first.heroPane.clientHeight;
        camera.updateProjectionMatrix();
      }
    }

    // First-paint signal — fires once the design image has decoded AND the
    // WebGL views have painted (so the hero + thumb canvases now show the
    // full design). The gallery reveal gate (mug-color-overlay.js) waits
    // for this on personalised products, keeping the mug + thumbnails
    // behind the loading shimmer until the whole thing is ready instead of
    // flashing a blank canvas while the (large) design webp downloads.
    var fbReadySignalled = false;
    function signalReady() {
      if (fbReadySignalled) return;
      fbReadySignalled = true;
      window.fbPersonaliserReady = true;
      document.dispatchEvent(new CustomEvent('fb-personaliser:ready'));
    }

    function renderAll() {
      // Always paint the flat preview — it doesn't need WebGL, just the
      // texture canvas which is updated by renderTexture.
      paintFlatPreview();

      if (!threeReady) return;
      texture.needsUpdate = true;
      var baseY    = -Math.PI * SHARED.wrap_fraction;
      var baseRoll = SHARED.mesh_roll || 0;
      VIEWS.forEach(function (v) {
        if (!v.renderer) return;
        mesh.rotation.y = baseY + v.rotationOffset;
        // Effective Z rotation per view: shared roll + this view's offset.
        // Lets each view compensate independently for camera roll in its
        // source photo (left/centre/right photos may not share the same
        // levelling).
        mesh.rotation.z = baseRoll + (v.rollOffset || 0);
        v.renderer.render(scene, camera);
        // Mirror onto the thumb canvas (cheap 2D blit from WebGL canvas)
        if (v.thumbCtx && v.canvas && v.thumbCanvas.width > 0) {
          v.thumbCtx.clearRect(0, 0, v.thumbCanvas.width, v.thumbCanvas.height);
          v.thumbCtx.drawImage(v.canvas, 0, 0, v.thumbCanvas.width, v.thumbCanvas.height);
        }
        // And mirror onto the duplicate clone canvas in the bottom-ATC
        // area (full-width-template products only — undefined elsewhere
        // and the if-guard keeps it free).
        if (v.cloneCtx && v.canvas && v.cloneCanvas.width > 0) {
          v.cloneCtx.clearRect(0, 0, v.cloneCanvas.width, v.cloneCanvas.height);
          v.cloneCtx.drawImage(v.canvas, 0, 0, v.cloneCanvas.width, v.cloneCanvas.height);
        }
      });

      // Whole design is now painted to every view → release the reveal gate
      // and lift the in-form flat-preview shimmer.
      if (designReady) {
        signalReady();
        if (root) root.classList.remove('fb-loading');
      }
    }

    function updatePreview() {
      var cleaned = sanitize(input.value);
      if (input.value !== cleaned) input.value = cleaned;
      charCountEl.textContent = cleaned.length + ' / ' + MAX + ' characters';
      charCountEl.classList.toggle('fb-charcount-maxed', cleaned.length >= MAX);
      sizeInput.value = maxSizeFor(cleaned.length);
      renderTexture(cleaned);
      renderAll();
    }

    // Resize handler runs in both modes (cylinder + flat preview need to
    // re-fit when viewport changes).
    window.addEventListener('resize', function () { resizeAll(); renderAll(); });

    if (IS_MF) {
      // Multi-field: every input (text or select) drives a re-render.
      // Token inputs trigger property re-resolution and re-render too.
      mfInputs.forEach(function (inp) {
        var ev = (inp.tagName === 'SELECT') ? 'change' : 'input';
        inp.addEventListener(ev, function () {
          updateMfTokenVisibility();
          updateMfFieldVisibility();   // show_when re-evaluation
          updateMfPropertyInputs();
          swapDesignImageIfNeeded();   // multi-design templates
          applyNameMesh();             // lift/shrink art when a name is present
          updatePickerGate();          // reveal font/colour once a name is typed
          renderMultiFieldTexture();
          renderAll();
        });
      });
      mfTokens.forEach(function (inp) {
        inp.addEventListener('input', function () {
          updateMfPropertyInputs();
          renderMultiFieldTexture();
          renderAll();
        });
      });
    } else {
      // Single-text: existing input + thickness handlers
      input.addEventListener('input', updatePreview);

      if (thicknessSlider) {
        thicknessSlider.addEventListener('input', function () {
          THICKNESS = parseFloat(thicknessSlider.value);
          if (thicknessValEl)  thicknessValEl.textContent  = THICKNESS;
          if (thicknessInput)  thicknessInput.value        = THICKNESS;
          renderTexture(sanitize(input.value));
          renderAll();
        });
      }
    }

    function boot() {
      // Safety net — never trap the flat preview behind the shimmer. If a
      // design is genuinely slow/broken, reveal whatever's there after 10s.
      setTimeout(function () { if (root) root.classList.remove('fb-loading'); }, 10000);
      // Initial pass — draws texture, updates char count for single-text
      // or syncs visibility/property inputs for multi-field.
      if (IS_MF) {
        updateMfTokenVisibility();
        updateMfFieldVisibility();   // hide rows whose show_when fails on first render
        updateMfPropertyInputs();
        renderMultiFieldTexture();
      } else {
        updatePreview();
      }
      loadThree(function () {
        initThree();
        // Once Three.js is up, re-render so the cylinder gets the texture.
        if (IS_MF) {
          renderMultiFieldTexture();
          renderAll();
        } else {
          updatePreview();
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            // Re-render with fonts loaded
            if (IS_MF) {
              renderMultiFieldTexture();
              renderAll();
            } else {
              updatePreview();
            }
          });
        }
      });
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(boot);
    } else {
      setTimeout(boot, 400);
    }

    // Hook the calibration block sets when ?fb_calibrate=1 is active.
    // Lets the size watcher re-read SHARED + VIEWS into the panel's
    // sliders after a mug shape swap, so the sliders stay in sync with
    // the actual values. Stays null when calibration is off.
    var refreshCalibrationUI = null;

    // ============================================================
    // Size watcher — swap mug shape on size variant change
    //
    // For products with a `size_mug_shapes` map (12oz Latte → latte
    // shape, Travel Mug → travel shape), the personaliser swaps the
    // bare-mug photos + camera/mesh/clip params when the customer
    // selects one of those sizes. Sizes not in the map keep the
    // template's primary mug_shape (already baked into SHARED + VIEWS
    // at page load).
    //
    // Three.js scene isn't recreated — only camera/mesh/clip params
    // are updated. The cylinder texture (design + customer text) is
    // shape-agnostic so it carries through unchanged.
    // ============================================================
    var SIZE_MAP = TPL.size_mug_shapes || {};

    // Recursively merge `override` onto `base`. Plain values in `override`
    // replace `base`; nested plain-objects merge recursively. Arrays are
    // treated as plain values (replace, not merge). Used for per-shape
    // overrides that may target nested fields (views.left.rotation_offset)
    // without clobbering siblings (views.centre, views.right).
    function deepMergeShape(base, override) {
      if (typeof override !== 'object' || override === null || Array.isArray(override)) {
        return override;
      }
      if (typeof base !== 'object' || base === null || Array.isArray(base)) {
        // Base isn't an object we can merge into — replace wholesale.
        var out0 = {};
        for (var k0 in override) if (override.hasOwnProperty(k0)) out0[k0] = override[k0];
        return out0;
      }
      var out = {};
      for (var k in base) if (base.hasOwnProperty(k)) out[k] = base[k];
      for (var k2 in override) {
        if (override.hasOwnProperty(k2)) {
          out[k2] = deepMergeShape(out[k2], override[k2]);
        }
      }
      return out;
    }

    // Snapshot the template's PRIMARY shape values so we can revert
    // to them when the customer picks a non-override size. Template-
    // level overrides (e.g. seventies edition's wider FOV) are part
    // of the primary snapshot — they only apply to sizes that DON'T
    // override the mug shape.
    var PRIMARY_SHAPE = {
      camera_fov:      SHARED.camera_fov,
      camera_distance: SHARED.camera_distance,
      mesh_tilt:       SHARED.mesh_tilt,
      mesh_roll:       SHARED.mesh_roll,
      mesh_x:          SHARED.mesh_x,
      mesh_y:          SHARED.mesh_y,
      mesh_scale:      SHARED.mesh_scale,
      mesh_scale_y:    SHARED.mesh_scale_y != null ? SHARED.mesh_scale_y : 1,
      design_aspect:   SHARED.design_aspect,
      wrap_fraction:   SHARED.wrap_fraction,
      radius_bottom:   SHARED.radius_bottom != null ? SHARED.radius_bottom : 1,
      single_view:     false,
      // Per-view clip + rotation/roll snapshots
      views: VIEWS.map(function (v) {
        return {
          id: v.id,
          rotationOffset: v.rotationOffset,
          rollOffset:     v.rollOffset,
          clipLeft:       v.clipLeft,
          clipRight:      v.clipRight,
          clipTop:        v.clipTop,
          clipBottom:     v.clipBottom,
          clipLeftSlant:  v.clipLeftSlant,
          clipRightSlant: v.clipRightSlant,
        };
      }),
    };

    // Capture the original bare-mug image src/srcset so we can revert
    // after switching back from an override size.
    var primaryHeroImgs = {};
    var primaryThumbImgs = {};
    ['left', 'centre', 'right'].forEach(function (vid) {
      var heroPane = document.querySelector('[data-fb-hero-pane="' + vid + '"]');
      var thumb    = document.querySelector('[data-fb-thumb-view="' + vid + '"]');
      if (heroPane) {
        // Direct-child <img> only — skip overlay imgs that may also exist
        // inside the pane (e.g. fb-photo-default-overlay's <img>).
        var heroImg = heroPane.querySelector(':scope > img');
        if (heroImg) primaryHeroImgs[vid] = { src: heroImg.src, srcset: heroImg.srcset };
      }
      if (thumb) {
        var thumbImg = thumb.querySelector(':scope > img');
        if (thumbImg) primaryThumbImgs[vid] = { src: thumbImg.src, srcset: thumbImg.srcset };
      }
    });

    var galleryWrap = document.querySelector('[data-fb-gallery]');

    // ---- photo-default-overlay size-specific swap ----------------------
    // For photo-mug templates (image fields), the default-state overlay
    // shows the product's marketing image until the customer uploads
    // their first photo. On Latte / Travel Mug, swap that overlay to
    // the size-specific pre-warped composite (`{handle}.webp` and
    // `travelmug-{handle}.webp` from Shopify Files — same images the
    // non-personalised gallery uses).
    //
    // Only meaningful when the product has the corresponding has_*_image
    // metafield set (Liquid only emits the data-*-hero-url attributes
    // when those are true, so the lookup naturally short-circuits when
    // the file doesn't exist).
    var heroOverlay   = document.querySelector('[data-fb-photo-default-overlay]');
    var thumbOverlays = document.querySelectorAll('[data-fb-photo-default-thumb-overlay]');

    // Snapshot original src/srcset so we can revert on size change away
    // from Latte / Travel Mug. We capture per-element to handle the
    // distinct thumb overlays that started life with different srcs.
    function snapshotOverlayImg(wrap) {
      if (!wrap) return null;
      var img = wrap.querySelector(':scope > img');
      if (!img) return null;
      return { wrap: wrap, img: img, src: img.src, srcset: img.srcset };
    }
    var heroOverlaySnap   = snapshotOverlayImg(heroOverlay);
    var thumbOverlaySnaps = [];
    thumbOverlays.forEach(function (w) {
      var snap = snapshotOverlayImg(w);
      if (snap) thumbOverlaySnaps.push(snap);
    });

    function applyPhotoDefaultOverlayForSize(sizeName) {
      var pickUrl = function (wrap) {
        if (!wrap) return null;
        if (sizeName === '12oz Latte')  return wrap.dataset.latteHeroUrl    || null;
        if (sizeName === 'Travel Mug')  return wrap.dataset.travelmugHeroUrl || null;
        return null;
      };
      function applyTo(snap) {
        if (!snap) return;
        var url = pickUrl(snap.wrap);
        if (url) {
          snap.img.src    = url;
          snap.img.srcset = '';
        } else {
          // Restore original src/srcset for non-override sizes.
          snap.img.src    = snap.src;
          snap.img.srcset = snap.srcset;
        }
      }
      applyTo(heroOverlaySnap);
      thumbOverlaySnaps.forEach(applyTo);
    }

    // Apply a mug shape (override or primary) — updates SHARED, VIEWS,
    // bare-mug image srcs, and triggers a re-render. Idempotent: same
    // shape applied twice is a no-op visually.
    function applyMugShape(shapeData) {
      // 0. Merge in template's per-shape overrides for fields that vary
      //    by both template AND shape (design_aspect, wrap_fraction,
      //    mesh_y, mesh_scale_y, view_calibration, etc.). Per-shape
      //    override wins over the shape's universal value. Lookup is
      //    by shape handle. No-op when the active template has no
      //    overrides for this shape, or when applying the primary
      //    shape (no handle).
      //
      //    Deep merge so a partial override (e.g. only views.left.rotation_offset)
      //    leaves the rest of views untouched. Plain values replace; nested
      //    objects merge recursively.
      if (shapeData && shapeData.handle && TPL.per_shape_overrides) {
        var perShape = TPL.per_shape_overrides[shapeData.handle];
        if (perShape) {
          shapeData = deepMergeShape(shapeData, perShape);
        }
      }

      // 1. SHARED (camera + mesh defaults). mesh_y / mesh_scale /
      //    mesh_scale_y / design_aspect / wrap_fraction are optional
      //    per-shape overrides; Liquid emission falls back to the
      //    template's primary values when a shape doesn't set them, so
      //    shapeData always carries usable numbers.
      // Snapshot the values that affect canvas dimensions / geometry
      // BEFORE we mutate SHARED, so we know whether to do the heavier
      // texture-resize + geometry-rebuild work below.
      var oldAspect = SHARED.design_aspect;
      var oldWrap   = SHARED.wrap_fraction;
      var oldRBot   = SHARED.radius_bottom != null ? SHARED.radius_bottom : 1;
      SHARED.camera_fov      = shapeData.camera_fov;
      SHARED.camera_distance = shapeData.camera_distance;
      SHARED.mesh_tilt       = shapeData.mesh_tilt;
      SHARED.mesh_roll       = shapeData.mesh_roll;
      if (shapeData.mesh_x       != null) SHARED.mesh_x       = shapeData.mesh_x;
      if (shapeData.mesh_y       != null) SHARED.mesh_y       = shapeData.mesh_y;
      if (shapeData.mesh_scale   != null) SHARED.mesh_scale   = shapeData.mesh_scale;
      if (shapeData.mesh_scale_y != null) SHARED.mesh_scale_y = shapeData.mesh_scale_y;
      // Re-anchor the name-mesh base to this shape's no-name values, then
      // re-apply the name shift so it survives a size/shape switch.
      nameShapeBaseY      = SHARED.mesh_y;
      nameShapeBaseScale  = SHARED.mesh_scale;
      nameShapeBaseScaleY = SHARED.mesh_scale_y != null ? SHARED.mesh_scale_y : 1;
      if (shapeData.design_aspect != null) SHARED.design_aspect = shapeData.design_aspect;
      nameShapeBaseAspect = SHARED.design_aspect != null ? SHARED.design_aspect : 1;
      applyNameMesh();
      if (shapeData.wrap_fraction != null) SHARED.wrap_fraction = shapeData.wrap_fraction;
      if (shapeData.radius_bottom != null) SHARED.radius_bottom = shapeData.radius_bottom;

      // 2. Per-view calibration. For single-view shapes, only `centre`
      //    is provided — left/right keep their existing values (they're
      //    hidden anyway via the single-view CSS class).
      VIEWS.forEach(function (v) {
        var vc = (shapeData.views || {})[v.id];
        if (!vc) return;
        v.rotationOffset = vc.rotation_offset != null ? vc.rotation_offset : 0;
        v.rollOffset     = vc.roll_offset     != null ? vc.roll_offset     : 0;
        var clip = vc.clip || [30, 70, 10, 78, 0, 0];
        v.clipLeft       = clip[0];
        v.clipRight      = clip[1];
        v.clipTop        = clip[2];
        v.clipBottom     = clip[3];
        v.clipLeftSlant  = clip[4] || 0;
        v.clipRightSlant = clip[5] || 0;
      });

      // 3. Swap bare-mug photos in the hero panes + thumbs.
      var imgMap = {
        left:   { hero: shapeData.blank_left_url,   thumb: shapeData.blank_left_thumb_url   },
        centre: { hero: shapeData.blank_centre_url, thumb: shapeData.blank_centre_thumb_url },
        right:  { hero: shapeData.blank_right_url,  thumb: shapeData.blank_right_thumb_url  },
      };
      Object.keys(imgMap).forEach(function (vid) {
        var urls = imgMap[vid];
        if (!urls.hero) return;
        var heroPane = document.querySelector('[data-fb-hero-pane="' + vid + '"]');
        if (heroPane) {
          // Direct child <img> only — skip overlay imgs that may also
          // exist inside the pane (e.g. fb-photo-default-overlay).
          var heroImg = heroPane.querySelector(':scope > img');
          if (heroImg) {
            heroImg.src    = urls.hero;
            heroImg.srcset = '';  // nuke srcset so the browser uses src
          }
        }
        var thumb = document.querySelector('[data-fb-thumb-view="' + vid + '"]');
        if (thumb) {
          var thumbImg = thumb.querySelector(':scope > img');
          if (thumbImg) {
            thumbImg.src    = urls.thumb || urls.hero;
            thumbImg.srcset = '';
          }
        }
        // Same swap for the clone thumbs in the section's bottom area
        // (full-width-template products only). Without this the bottom
        // thumbs keep showing the original mug shape's photo even after
        // the customer picks Latte / Travel Mug.
        var cloneThumb = document.querySelector('[data-fb-thumb-clone-view="' + vid + '"]');
        if (cloneThumb) {
          var cloneImg = cloneThumb.querySelector(':scope > img:not(.mug-color-overlay)');
          if (cloneImg) {
            cloneImg.src    = urls.thumb || urls.hero;
            cloneImg.srcset = '';
          }
        }
      });

      // 4. Single-view UI toggle on the gallery wrapper. CSS uses this
      //    to hide left/right hero panes + thumbs.
      if (galleryWrap) {
        galleryWrap.classList.toggle('fb-gallery--single-view', !!shapeData.single_view);
      }
      // Also toggle on the thumbs wrap, which is a sibling of the
      // gallery — single-view also collapses the thumbnail row.
      var thumbsWrap = document.querySelector('.sp-thumbs-wrap');
      if (thumbsWrap) {
        thumbsWrap.classList.toggle('fb-thumbs--single-view', !!shapeData.single_view);
      }
      // If switching to single-view while a non-centre view is active,
      // force the active view to centre. Mirror to clone thumbs so
      // their is-active class also moves to centre.
      if (shapeData.single_view) {
        VIEWS.forEach(function (v) {
          var pane  = document.querySelector('[data-fb-hero-pane="' + v.id + '"]');
          var thumb = document.querySelector('[data-fb-thumb-view="' + v.id + '"]');
          var clone = document.querySelector('[data-fb-thumb-clone-view="' + v.id + '"]');
          var isActive = (v.id === 'centre');
          if (pane)  pane.classList.toggle('is-active', isActive);
          if (thumb) thumb.classList.toggle('is-active', isActive);
          if (clone) clone.classList.toggle('is-active', isActive);
        });
      }
      // Toggle the clone-thumbs container too — Travel Mug / single-
      // view shapes should show only the centre clone, hiding left/right.
      var cloneThumbsWrap = document.querySelector('[data-fb-thumb-clones]');
      if (cloneThumbsWrap) {
        cloneThumbsWrap.classList.toggle('fb-thumbs--single-view', !!shapeData.single_view);
      }

      // 5. If design_aspect changed, the texture canvas needs resizing
      //    (its height is derived from design_aspect) and the GPU
      //    texture needs a fresh upload (CanvasTexture doesn't always
      //    handle source-canvas resizes cleanly). If wrap_fraction or
      //    design_aspect changed, the cylinder geometry needs a rebuild
      //    (height + thetaLength both depend on these).
      var aspectChanged = SHARED.design_aspect !== oldAspect;
      var wrapChanged   = SHARED.wrap_fraction !== oldWrap;
      var rBotChanged   = (SHARED.radius_bottom != null ? SHARED.radius_bottom : 1) !== oldRBot;
      if (aspectChanged) {
        resizeTextureCanvas();
        renderTextureMain();
        rebuildTexture();
      }

      // 6. Push to scene + repaint clips + re-render. Rebuild geometry
      //    whenever design_aspect, wrap_fraction or radius_bottom
      //    changed (any of these changes the cylinder shape).
      applySharedToScene(aspectChanged || wrapChanged || rBotChanged);
      VIEWS.forEach(applyClipForView);
      renderAll();

      // 7. If the calibration panel is active, re-read SHARED + VIEWS
      //    into its sliders so they reflect the new shape's values
      //    rather than holding the previous shape's stale numbers.
      if (typeof refreshCalibrationUI === 'function') refreshCalibrationUI();
    }

    // Build a "primary shape" object on demand (used to revert from an
    // override size back to a non-override size). Mirrors the shape of
    // an override entry but pulls values from PRIMARY_SHAPE + the
    // captured img URLs.
    function buildPrimaryShapeData() {
      var viewsOut = {};
      PRIMARY_SHAPE.views.forEach(function (v) {
        viewsOut[v.id] = {
          rotation_offset: v.rotationOffset,
          roll_offset:     v.rollOffset,
          clip: [
            v.clipLeft, v.clipRight, v.clipTop, v.clipBottom,
            v.clipLeftSlant, v.clipRightSlant,
          ],
        };
      });
      return {
        camera_fov:      PRIMARY_SHAPE.camera_fov,
        camera_distance: PRIMARY_SHAPE.camera_distance,
        mesh_tilt:       PRIMARY_SHAPE.mesh_tilt,
        mesh_roll:       PRIMARY_SHAPE.mesh_roll,
        mesh_x:          PRIMARY_SHAPE.mesh_x,
        mesh_y:          PRIMARY_SHAPE.mesh_y,
        mesh_scale:      PRIMARY_SHAPE.mesh_scale,
        mesh_scale_y:    PRIMARY_SHAPE.mesh_scale_y,
        design_aspect:   PRIMARY_SHAPE.design_aspect,
        wrap_fraction:   PRIMARY_SHAPE.wrap_fraction,
        radius_bottom:   PRIMARY_SHAPE.radius_bottom,
        single_view:     false,
        blank_left_url:         (primaryHeroImgs.left   || {}).src,
        blank_centre_url:       (primaryHeroImgs.centre || {}).src,
        blank_right_url:        (primaryHeroImgs.right  || {}).src,
        blank_left_thumb_url:   (primaryThumbImgs.left   || {}).src,
        blank_centre_thumb_url: (primaryThumbImgs.centre || {}).src,
        blank_right_thumb_url:  (primaryThumbImgs.right  || {}).src,
        views: viewsOut,
      };
    }

    var currentShapeKey = null;  // null = primary; otherwise size key
    function syncShapeForSize(sizeName) {
      // Photo-default overlay swap runs for EVERY size change, not just
      // shape-override ones. Even within ceramic sizes (10/11/15/20oz)
      // the overlay should stay on the original featured image — the
      // pickUrl logic handles that by returning null for non-override
      // sizes.
      applyPhotoDefaultOverlayForSize(sizeName);

      var override = sizeName ? SIZE_MAP[sizeName] : null;
      var newKey = override ? sizeName : null;
      if (newKey === currentShapeKey) return;  // no change
      currentShapeKey = newKey;
      applyMugShape(override || buildPrimaryShapeData());
    }

    // Pull size from a Shopify variant object (option1/2/3) — match
    // any option value against our known size keys.
    function findSizeInVariant(variant) {
      if (!variant) return null;
      for (var i = 1; i <= 3; i++) {
        var val = variant['option' + i];
        if (val && SIZE_MAP[val]) return val;
      }
      // Also handle the case where current size is a non-override
      // size (e.g. 11oz) — return the value matching the product's
      // 'Size' option name where possible. For now, just return null
      // and let the caller treat that as "primary".
      return null;
    }

    // Helper — defer applying a shape until threeReady, with timeout.
    function syncShapeWhenReady(sizeName) {
      if (typeof threeReady !== 'undefined' && threeReady) {
        syncShapeForSize(sizeName);
        return;
      }
      var tries = 0;
      var iv = setInterval(function () {
        if (typeof threeReady !== 'undefined' && threeReady) {
          clearInterval(iv);
          syncShapeForSize(sizeName);
        } else if (++tries > 50) {
          clearInterval(iv);
        }
      }, 100);
    }

    // Integration A — standard variant-picker event (some products use
    // this; harmless if it never fires for products that use the
    // sipfull custom picker).
    document.addEventListener('on:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      syncShapeWhenReady(findSizeInVariant(variant));
    });

    // Integration B — sipfull custom picker.
    //
    // Originally a click handler on the size picker, but that misses
    // size changes that happen as a SIDE-EFFECT of clicking other
    // pickers — e.g. changing Material from Polymer to Bone China
    // while on Travel Mug pivots size to 10oz (Travel Mug doesn't
    // support Bone China). The click event fires on the material
    // picker, and our handler on the size picker never sees it.
    //
    // MutationObserver catches any change to the size picker's
    // `.active` class state regardless of how it was triggered —
    // direct click, material/colour-pivot side-effect, programmatic
    // update, etc.
    var sizePicker = document.querySelector('[data-picker="size"]');
    if (sizePicker && typeof MutationObserver !== 'undefined') {
      var lastObservedSize = null;
      var sizeObserver = new MutationObserver(function () {
        var active = sizePicker.querySelector('[data-value].active');
        var sizeName = active ? active.getAttribute('data-value') : null;
        if (sizeName !== lastObservedSize) {
          lastObservedSize = sizeName;
          syncShapeWhenReady(sizeName);
        }
      });
      sizeObserver.observe(sizePicker, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });
    }

    // Initial state — if the page loaded with an override size already
    // selected (e.g. customer followed a variant deep link), apply
    // that shape once Three is ready. Detect via the active size in
    // the current variant: read it from the form's selected option
    // or from any active size button.
    function detectInitialSize() {
      // Try sipfull picker first (active-state buttons).
      var active = document.querySelector('[data-picker="size"] [data-value].active');
      if (active) return active.getAttribute('data-value');
      // Fall back to variant selectors.
      var sel = document.querySelector('[name^="options["]');
      if (sel && sel.value && SIZE_MAP[sel.value]) return sel.value;
      return null;
    }
    (function applyInitialShape() {
      var sizeName = detectInitialSize();
      if (!sizeName || !SIZE_MAP[sizeName]) return;
      var tries = 0;
      var iv = setInterval(function () {
        if (typeof threeReady !== 'undefined' && threeReady) {
          clearInterval(iv);
          syncShapeForSize(sizeName);
        } else if (++tries > 50) {
          clearInterval(iv);
        }
      }, 100);
    })();

    // ============================================================
    // Calibration panel — gated by ?fb_calibrate=1
    //
    // Sliders override SHARED + per-view values locally (not the
    // metaobject). User copies final values into the metaobject in
    // admin when they're happy.
    // ============================================================
    var calibrateActive = /[?&]fb_calibrate=1\b/.test(window.location.search);
    var calibratePanel  = root.querySelector('[data-fb-calibrate]');
    if (calibrateActive && calibratePanel) {
      calibratePanel.classList.add('fb-calibrate-visible');
      // Reparent to body so no ancestor transform can trap position:fixed
      // (some product sections wrap the personaliser in a transformed
      // container that clips fixed children). Deferred to the next tick
      // so the slider-binding code below still finds the panel via
      // root.querySelector before the move.
      setTimeout(function () {
        try { document.body.appendChild(calibratePanel); } catch(_) {}
      }, 0);

      // Map slider key → which property to set on what
      var SHARED_KEYS = {
        fov:    { prop: 'camera_fov',      decimals: 1, rebuild: false },
        dist:   { prop: 'camera_distance', decimals: 1, rebuild: false },
        aspect: { prop: 'design_aspect',   decimals: 3, rebuild: true  },
        wrap:   { prop: 'wrap_fraction',   decimals: 2, rebuild: true  },
        mx:     { prop: 'mesh_x',          decimals: 2, rebuild: false },
        my:     { prop: 'mesh_y',          decimals: 2, rebuild: false },
        ms:     { prop: 'mesh_scale',      decimals: 2, rebuild: false },
        msy:    { prop: 'mesh_scale_y',    decimals: 2, rebuild: false },
        rbot:   { prop: 'radius_bottom',   decimals: 2, rebuild: true  },
        tilt:   { prop: 'mesh_tilt',       decimals: 2, rebuild: false },
        roll:   { prop: 'mesh_roll',       decimals: 2, rebuild: false },
        tv:     { prop: 'text_vertical',   decimals: 2, rebuild: false },
        soft:   { prop: 'edge_softness',   decimals: 1, rebuild: false },
        dscale: { prop: 'design_scale',    decimals: 2, rebuild: false },
        doff:   { prop: 'design_offset_y', decimals: 2, rebuild: false },
      };

      function fmt(v, d) { return parseFloat(v).toFixed(d); }
      function viewById(id) {
        for (var i = 0; i < VIEWS.length; i++) if (VIEWS[i].id === id) return VIEWS[i];
        return null;
      }

      var outEl = root.querySelector('[data-fb-calibrate-out]');

      // ============================================================
      // Copy button — copies the current readout to the clipboard.
      // Two-path strategy:
      //   1. navigator.clipboard.writeText() — modern, async, requires
      //      a secure context (HTTPS, which the storefront always is).
      //   2. document.execCommand('copy') fallback for older browsers.
      // Visual feedback: button briefly turns green and says "Copied".
      // ============================================================
      var copyBtn = root.querySelector('[data-fb-calibrate-copy]');
      if (copyBtn && outEl) {
        copyBtn.addEventListener('click', function () {
          var text = outEl.textContent || '';
          var done = function () {
            copyBtn.textContent = 'Copied';
            copyBtn.setAttribute('data-state', 'copied');
            setTimeout(function () {
              copyBtn.textContent = 'Copy';
              copyBtn.removeAttribute('data-state');
            }, 1400);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done, function () {
              // Permission rejected — fall through to the legacy path.
              legacyCopy(text, done);
            });
          } else {
            legacyCopy(text, done);
          }
        });
      }
      function legacyCopy(text, onDone) {
        // Mount a throw-away textarea off-screen, select it, exec copy.
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) { /* nothing else to do */ }
        document.body.removeChild(ta);
        if (onDone) onDone();
      }

      function refreshOutput() {
        var lines = [
          '// Shared (template metaobject + mug shape metaobject)',
          'camera_fov:      ' + fmt(SHARED.camera_fov, 1),
          'camera_distance: ' + fmt(SHARED.camera_distance, 1),
          'design_aspect:   ' + fmt(SHARED.design_aspect, 3),
          'wrap_fraction:   ' + fmt(SHARED.wrap_fraction, 2),
          'mesh_x:          ' + fmt(SHARED.mesh_x, 2),
          'mesh_y:          ' + fmt(SHARED.mesh_y, 2),
          'mesh_scale:      ' + fmt(SHARED.mesh_scale, 2),
          'mesh_scale_y:    ' + fmt(SHARED.mesh_scale_y != null ? SHARED.mesh_scale_y : 1, 2),
          'radius_bottom:   ' + fmt(SHARED.radius_bottom != null ? SHARED.radius_bottom : 1, 2),
          'mesh_tilt:       ' + fmt(SHARED.mesh_tilt, 2),
          'mesh_roll:       ' + fmt(SHARED.mesh_roll, 2),
          'text_vertical:   ' + fmt(SHARED.text_vertical, 2),
          'edge_softness:   ' + fmt(SHARED.edge_softness || 0, 1),
          'overlay_brightness: ' + fmt(SHARED.overlay_brightness != null ? SHARED.overlay_brightness : 0.95, 2),
          'design_scale:    ' + fmt(SHARED.design_scale != null ? SHARED.design_scale : 1, 2),
          'design_offset_y: ' + fmt(SHARED.design_offset_y != null ? SHARED.design_offset_y : 0, 2),
          '// Content schema (template metaobject)',
          'weathering:      ' + fmt(WEATHERING, 2),
        ];
        VIEWS.forEach(function (v) {
          lines.push('// ' + v.id + ' view (view_calibration: template overrides mug shape)');
          lines.push('rotation_offset: ' + fmt(v.rotationOffset, 2));
          lines.push('roll_offset:     ' + fmt(v.rollOffset || 0, 3));
          // 6-element clip: [left, right, top, bottom, leftSlant, rightSlant]
          lines.push('clip:            [' +
            fmt(v.clipLeft, 1) + ', ' +
            fmt(v.clipRight, 1) + ', ' +
            fmt(v.clipTop, 1) + ', ' +
            fmt(v.clipBottom, 1) + ', ' +
            fmt(v.clipLeftSlant, 1) + ', ' +
            fmt(v.clipRightSlant, 1) + ']');
        });

        // Multi-field per-field positioning + sizing
        if (IS_MF) {
          (TPL.fields || []).forEach(function (field) {
            // Skip design-driver selects — no anchors to dump.
            if (field.design_key_part) return;
            lines.push('// field "' + field.name + '" (' + field.label + ')');
            if (field.type === 'image') {
              // Image-field positioning — paste these back into the
              // metaobject's content_schema for the corresponding field.
              lines.push('  anchor_x:        ' + fmt(field.anchor_x != null ? field.anchor_x : 0.5, 4));
              lines.push('  anchor_y:        ' + fmt(field.anchor_y != null ? field.anchor_y : 0.5, 4));
              lines.push('  width_frac:      ' + fmt(field.width_frac  != null ? field.width_frac  : 0.5, 4));
              lines.push('  height_frac:     ' + fmt(field.height_frac != null ? field.height_frac : 0.5, 4));
              lines.push('  rotation:        ' + fmt(parseFloat(field.rotation) || 0, 2));
            } else {
              lines.push('  anchor_x:        ' + fmt(field.anchor_x != null ? field.anchor_x : 0.5, 4));
              lines.push('  anchor_y:        ' + fmt(field.anchor_y != null ? field.anchor_y : 0.5, 4));
              lines.push('  max_width_frac:  ' + fmt(field.max_width_frac != null ? field.max_width_frac : 0.95, 2));
              // Show scaled size_caps + size_fallback so user can paste back
              // into metaobject when size_scale != 1.
              if (field._origSizeCaps) {
                var capsParts = [];
                Object.keys(field._origSizeCaps).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); }).forEach(function (k) {
                  capsParts.push('"' + k + '": ' + (field._origSizeCaps[k] * (field._sizeScale || 1)).toFixed(1));
                });
                lines.push('  size_caps:       {' + capsParts.join(', ') + '}');
                lines.push('  size_fallback:   ' + ((field._origSizeFallback || 0) * (field._sizeScale || 1)).toFixed(1));
              }
              // Per-value overrides readout — dumps each key that the
              // override actually defines, so the customer can paste
              // a partial entry back into the metaobject (the engine
              // shallow-merges overrides on top of the base, so any
              // key not present here inherits from the base).
              if (field.overrides_by && field.overrides) {
                lines.push('  overrides_by:    "' + field.overrides_by + '"');
                lines.push('  overrides: {');
                Object.keys(field.overrides).forEach(function (key) {
                  var ov = field.overrides[key];
                  var parts = [];
                  if (ov.anchor_x != null)       parts.push('"anchor_x": ' + fmt(ov.anchor_x, 4));
                  if (ov.anchor_y != null)       parts.push('"anchor_y": ' + fmt(ov.anchor_y, 4));
                  if (ov.max_width_frac != null) parts.push('"max_width_frac": ' + fmt(ov.max_width_frac, 2));
                  // size_caps + size_fallback come together — emit
                  // both when size_caps is set so the consumer doesn't
                  // end up with a stale fallback.
                  if (ov.size_caps) {
                    var capsParts = [];
                    Object.keys(ov.size_caps).sort(function (a, b) {
                      return parseInt(a, 10) - parseInt(b, 10);
                    }).forEach(function (k) {
                      capsParts.push('"' + k + '": ' + ov.size_caps[k].toFixed(1));
                    });
                    parts.push('"size_caps": {' + capsParts.join(', ') + '}');
                    parts.push('"size_fallback": ' + ((ov.size_fallback != null ? ov.size_fallback : 0)).toFixed(1));
                  }
                  lines.push('    "' + key + '": { ' + parts.join(', ') + ' }');
                });
                lines.push('  }');
              }
            }
          });
        }

        outEl.textContent = lines.join('\n');
      }

      // (applySharedToScene is hoisted to IIFE-level so the size watcher
      // can reuse it.)

      // Initialise SHARED sliders from current TPL config + wire input
      Object.keys(SHARED_KEYS).forEach(function (key) {
        var cfg = SHARED_KEYS[key];
        var slider = root.querySelector('[data-cs="' + key + '"]');
        var valEl  = root.querySelector('[data-cv="' + key + '"]');
        if (!slider) return;
        slider.value = SHARED[cfg.prop];
        if (valEl) valEl.textContent = fmt(SHARED[cfg.prop], cfg.decimals);
        slider.addEventListener('input', function () {
          var v = parseFloat(slider.value);
          SHARED[cfg.prop] = v;
          if (valEl) valEl.textContent = fmt(v, cfg.decimals);
          if (cfg.prop === 'design_aspect') {
            resizeTextureCanvas();
            renderTextureMain();
            // Canvas dimensions changed → force a fresh GPU texture
            // upload, otherwise we get ghost vertical tiling because
            // the old texture's dimensions don't match the new canvas.
            rebuildTexture();
          }
          if (cfg.prop === 'text_vertical') {
            renderTextureMain();
          }
          if (cfg.prop === 'design_scale' || cfg.prop === 'design_offset_y') {
            // These change the design layer on the texture, so re-render it.
            renderTextureMain();
          }
          if (cfg.prop === 'edge_softness') {
            // Mask is generated per-view from SHARED.edge_softness, so all
            // three views need their clip re-applied on change.
            VIEWS.forEach(applyClipForView);
          }
          applySharedToScene(cfg.rebuild);
          renderAll();
          refreshOutput();
        });
      });

      // Weathering slider — drives the WEATHERING var which renderTexture
      // reads. Lives on the text field (content schema), not SHARED, but
      // sits in the same shared block of the calibration panel for ease.
      var wearSlider = root.querySelector('[data-cs="wear"]');
      var wearValEl  = root.querySelector('[data-cv="wear"]');
      if (wearSlider) {
        wearSlider.value = WEATHERING;
        if (wearValEl) wearValEl.textContent = fmt(WEATHERING, 2);
        wearSlider.addEventListener('input', function () {
          WEATHERING = parseFloat(wearSlider.value);
          if (wearValEl) wearValEl.textContent = fmt(WEATHERING, 2);
          renderTextureMain();
          renderAll();
          refreshOutput();
        });
      }

      // Overlay brightness slider — multiplies the design layer's
      // brightness (designFilter() reads SHARED.overlay_brightness). Lives
      // in SHARED, dumped in the copy output so the value can be pasted
      // into the template metaobject's overlay_brightness field.
      var brightSlider = root.querySelector('[data-cs="bright"]');
      var brightValEl  = root.querySelector('[data-cv="bright"]');
      if (brightSlider) {
        var initBright = (SHARED.overlay_brightness != null) ? SHARED.overlay_brightness : 0.95;
        brightSlider.value = initBright;
        if (brightValEl) brightValEl.textContent = fmt(initBright, 2);
        brightSlider.addEventListener('input', function () {
          SHARED.overlay_brightness = parseFloat(brightSlider.value);
          if (brightValEl) brightValEl.textContent = fmt(SHARED.overlay_brightness, 2);
          renderTextureMain();
          renderAll();
          refreshOutput();
        });
      }

      // Initialise per-view sliders + wire input
      var perViewInputs = root.querySelectorAll('[data-cs][data-view]');
      perViewInputs.forEach(function (slider) {
        var viewId = slider.getAttribute('data-view');
        var prop   = slider.getAttribute('data-prop');
        var key    = slider.getAttribute('data-cs');
        var v      = viewById(viewId);
        var valEl  = root.querySelector('[data-cv="' + key + '"]');
        if (!v) return;
        // rollOffset is small (e.g. -0.01) so needs 3 decimals to be readable;
        // rotationOffset uses 2; clip values use 1.
        var decimals = (prop === 'rollOffset') ? 3 :
                       (prop === 'rotationOffset') ? 2 : 1;
        slider.value = v[prop];
        if (valEl) valEl.textContent = fmt(v[prop], decimals);
        slider.addEventListener('input', function () {
          var newVal = parseFloat(slider.value);
          v[prop] = newVal;
          if (valEl) valEl.textContent = fmt(newVal, decimals);
          // rotation.y and rotation.z are both set inside renderAll per
          // view, so any change to either triggers a re-render. Clip
          // changes only need applyClipForView.
          if (prop === 'rotationOffset' || prop === 'rollOffset') {
            renderAll();
          } else {
            applyClipForView(v);
          }
          refreshOutput();
        });
      });

      // Expose a refresh function so the size watcher can re-sync the
      // panel's sliders + readout after a mug shape swap. Without this,
      // after switching size the sliders show the previous shape's
      // values while SHARED/VIEWS hold the new shape's — moving any
      // slider would then write a frankenstein blend back into state.
      refreshCalibrationUI = function () {
        // Re-read SHARED into the shared sliders + value displays
        Object.keys(SHARED_KEYS).forEach(function (key) {
          var cfg = SHARED_KEYS[key];
          var slider = root.querySelector('[data-cs="' + key + '"]');
          var valEl  = root.querySelector('[data-cv="' + key + '"]');
          if (!slider) return;
          slider.value = SHARED[cfg.prop];
          if (valEl) valEl.textContent = fmt(SHARED[cfg.prop], cfg.decimals);
        });
        // Re-read VIEWS into the per-view sliders + value displays
        perViewInputs.forEach(function (slider) {
          var viewId = slider.getAttribute('data-view');
          var prop   = slider.getAttribute('data-prop');
          var key    = slider.getAttribute('data-cs');
          var v      = viewById(viewId);
          var valEl  = root.querySelector('[data-cv="' + key + '"]');
          if (!v) return;
          var decimals = (prop === 'rollOffset') ? 3 :
                         (prop === 'rotationOffset') ? 2 : 1;
          slider.value = v[prop];
          if (valEl) valEl.textContent = fmt(v[prop], decimals);
        });
        refreshOutput();
      };

      // Multi-field templates get an extra "Field positioning" section
      // — anchor_y + size_scale sliders per field, populated based on
      // the template's content_schema.
      if (IS_MF) {
        var mfCalSection = root.querySelector('[data-mf-fields-calibrate]');
        if (mfCalSection) populateMfFieldSliders(mfCalSection);
      }

      refreshOutput();

      // ----------------------------------------------------------------
      // Multi-field calibration helpers
      // ----------------------------------------------------------------

      function buildMfSlider(label, opts, onInput) {
        var row = document.createElement('div');
        row.className = 'fb-calibrate-row';

        var labelEl = document.createElement('label');
        var valSpan = document.createElement('span');
        valSpan.className = 'val';
        valSpan.textContent = parseFloat(opts.value).toFixed(opts.decimals);
        labelEl.appendChild(document.createTextNode(label + ' '));
        labelEl.appendChild(valSpan);
        row.appendChild(labelEl);

        var slider = document.createElement('input');
        slider.type  = 'range';
        slider.min   = opts.min;
        slider.max   = opts.max;
        slider.step  = opts.step;
        slider.value = opts.value;
        slider.addEventListener('input', function () {
          var v = parseFloat(slider.value);
          valSpan.textContent = v.toFixed(opts.decimals);
          onInput(v);
        });
        row.appendChild(slider);
        return row;
      }

      // Build an anchor_x + anchor_y slider pair for a text/select field.
      // Used for both the BASE config (always-on) and the per-override
      // sub-section when a field declares overrides_by. The `target`
      // object is what the sliders mutate — either the field itself (for
      // base) or field.overrides[value] (for per-value overrides).
      // `baseValues` provides the fallback (e.g. the base anchor when
      // an override doesn't define its own).
      function buildMfAnchorSliders(grid, target, baseValues, anchorXKey, anchorYKey) {
        anchorXKey = anchorXKey || 'anchor_x';
        anchorYKey = anchorYKey || 'anchor_y';
        grid.appendChild(buildMfSlider(
          'Anchor X',
          { min: 0, max: 1, step: 0.002,
            value: target[anchorXKey] != null ? target[anchorXKey] : (baseValues && baseValues[anchorXKey] != null ? baseValues[anchorXKey] : 0.5),
            decimals: 4 },
          function (v) {
            target[anchorXKey] = v;
            renderMultiFieldTexture(); renderAll(); refreshOutput();
          }
        ));
        grid.appendChild(buildMfSlider(
          'Anchor Y',
          { min: 0, max: 1, step: 0.002,
            value: target[anchorYKey] != null ? target[anchorYKey] : (baseValues && baseValues[anchorYKey] != null ? baseValues[anchorYKey] : 0.5),
            decimals: 4 },
          function (v) {
            target[anchorYKey] = v;
            renderMultiFieldTexture(); renderAll(); refreshOutput();
          }
        ));
      }

      function populateMfFieldSliders(container) {
        (TPL.fields || []).forEach(function (field) {
          // Skip design-key-part selects — they have no canvas position
          // to calibrate (they're pure design-swap drivers, like the
          // Colour / Kids dropdowns on Daddy's Team).
          if (field.design_key_part) return;

          var fieldDiv = document.createElement('div');
          fieldDiv.style.cssText =
            'margin-top:10px; padding-top:10px; border-top:1px dashed #d8b89a;';

          var titleDiv = document.createElement('div');
          titleDiv.style.cssText =
            'font-weight:600; font-size:11px; color:#555; margin-bottom:6px; ' +
            'text-transform:uppercase; letter-spacing:0.04em;';
          titleDiv.textContent = field.label || field.name;
          fieldDiv.appendChild(titleDiv);

          var grid = document.createElement('div');
          grid.className = 'fb-calibrate-grid';

          if (field.type === 'image') {
            // Image fields: anchor_x, anchor_y, width_frac, height_frac
            grid.appendChild(buildMfSlider(
              'Anchor X',
              { min: 0, max: 1, step: 0.002,
                value: field.anchor_x != null ? field.anchor_x : 0.5,
                decimals: 4 },
              function (v) {
                field.anchor_x = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));
            grid.appendChild(buildMfSlider(
              'Anchor Y',
              { min: 0, max: 1, step: 0.002,
                value: field.anchor_y != null ? field.anchor_y : 0.5,
                decimals: 4 },
              function (v) {
                field.anchor_y = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));
            grid.appendChild(buildMfSlider(
              'Width frac',
              { min: 0.05, max: 0.5, step: 0.002,
                value: field.width_frac != null ? field.width_frac : 0.2,
                decimals: 4 },
              function (v) {
                field.width_frac = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));
            grid.appendChild(buildMfSlider(
              'Height frac',
              { min: 0.1, max: 0.9, step: 0.002,
                value: field.height_frac != null ? field.height_frac : 0.5,
                decimals: 4 },
              function (v) {
                field.height_frac = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));
            // Rotation (degrees). Tilted polaroid frames need a small
            // rotation so the photo aligns with the frame's slant.
            grid.appendChild(buildMfSlider(
              'Rotation°',
              { min: -15, max: 15, step: 0.1,
                value: parseFloat(field.rotation) || 0,
                decimals: 2 },
              function (v) {
                field.rotation = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));
          } else {
            // Text/select fields: anchor_x, anchor_y, size_scale,
            // max_width_frac. Snapshot originals so size_scale is
            // relative to the metaobject values rather than
            // compounding on each tweak.
            field._origSizeCaps     = JSON.parse(JSON.stringify(field.size_caps || {}));
            field._origSizeFallback = field.size_fallback != null ? field.size_fallback : 50;
            field._sizeScale        = 1.0;

            // Base anchors (always present) — apply when the field
            // either has no overrides_by or the controller's value
            // doesn't match a key in overrides.
            buildMfAnchorSliders(grid, field, null);

            grid.appendChild(buildMfSlider(
              'Size scale',
              { min: 0.3, max: 2.0, step: 0.02,
                value: 1.0, decimals: 2 },
              function (v) {
                field._sizeScale = v;
                field.size_caps = {};
                Object.keys(field._origSizeCaps).forEach(function (k) {
                  field.size_caps[k] = field._origSizeCaps[k] * v;
                });
                field.size_fallback = field._origSizeFallback * v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));

            var origMaxWidth = field.max_width_frac != null ? field.max_width_frac : 0.95;
            grid.appendChild(buildMfSlider(
              'Max width',
              { min: 0.3, max: 1, step: 0.01,
                value: origMaxWidth, decimals: 2 },
              function (v) {
                field.max_width_frac = v;
                renderMultiFieldTexture(); renderAll(); refreshOutput();
              }
            ));

          }

          // Append the BASE grid first — overrides sub-sections (if
          // any) follow it. Image-field branch hits this path too;
          // its `grid` only has image sliders, no override sub-grids.
          fieldDiv.appendChild(grid);

          // Per-value overrides — a field can declare `overrides_by`
          // (the controller field name) plus an `overrides` map
          // keyed on values of that controller. Each override entry
          // gets its own block of sliders (anchor X/Y, size scale,
          // max width) so each layout can be tuned independently.
          // To preview a specific override, change the controller
          // field's value in the FORM above — the engine picks up
          // the override automatically and re-renders.
          if (field.type !== 'image' && field.overrides_by && field.overrides) {
            Object.keys(field.overrides).forEach(function (key) {
              var sub = field.overrides[key];

              // Sub-heading marks the override block.
              var subTitle = document.createElement('div');
              subTitle.style.cssText =
                'font-weight:500; font-size:10px; color:#777; ' +
                'margin:8px 0 4px; text-transform:uppercase; letter-spacing:0.04em;';
              subTitle.textContent = 'When ' + field.overrides_by + ' = "' + key + '"';
              fieldDiv.appendChild(subTitle);

              var subGrid = document.createElement('div');
              subGrid.className = 'fb-calibrate-grid';

              // Anchor X / Y for this override.
              buildMfAnchorSliders(subGrid, sub, field);

              // Size scale slider — multiplier RELATIVE to the base
              // field's current size_caps (which reflect any base
              // size_scale tweaks). Useful when a layout packs more
              // shirts into the same wrap width and text needs to
              // shrink. At 1.0 the override matches the base.
              //
              // Compounds with the base: if base scale was 0.88 and
              // override scale is 0.7, the effective override caps
              // are origs × 0.88 × 0.7. This means: "the 2-kid
              // layout is 70% of whatever the 1-kid layout is."
              // After changing base size_scale, re-nudge the
              // override slider to recompute (the override stores
              // absolute computed values, not a live ratio).
              sub._sizeScale = 1.0;
              subGrid.appendChild(buildMfSlider(
                'Size scale',
                { min: 0.3, max: 2.0, step: 0.02,
                  value: 1.0, decimals: 2 },
                function (v) {
                  sub._sizeScale = v;
                  // Resolve the current base values (post any base
                  // slider mutation), then scale them by v.
                  var baseCaps = field.size_caps && Object.keys(field.size_caps).length
                                 ? field.size_caps : field._origSizeCaps;
                  var baseFb   = field.size_fallback != null
                                 ? field.size_fallback : field._origSizeFallback;
                  sub.size_caps = {};
                  Object.keys(baseCaps).forEach(function (k) {
                    sub.size_caps[k] = baseCaps[k] * v;
                  });
                  sub.size_fallback = baseFb * v;
                  renderMultiFieldTexture(); renderAll(); refreshOutput();
                }
              ));

              // Max width slider — absolute (mirrors the base slider's
              // behaviour), starts at the override's existing max_width_frac
              // if set, else at the base's max_width_frac.
              var subMaxWidth = sub.max_width_frac != null ? sub.max_width_frac :
                                (field.max_width_frac != null ? field.max_width_frac : 0.95);
              subGrid.appendChild(buildMfSlider(
                'Max width',
                { min: 0.3, max: 1, step: 0.01,
                  value: subMaxWidth, decimals: 2 },
                function (v) {
                  sub.max_width_frac = v;
                  renderMultiFieldTexture(); renderAll(); refreshOutput();
                }
              ));

              fieldDiv.appendChild(subGrid);
            });
          }

          container.appendChild(fieldDiv);
        });
      }
    }

    // ============================================================
    // Thumb click → swap active hero pane
    // (Colour overlay sync is now handled by the existing
    // mug-color-overlay.js via the per-pane overlays the gallery emits.)
    // ============================================================
    (function initThumbSwap() {
      var thumbs = document.querySelectorAll('[data-fb-thumb-view]');
      if (!thumbs.length) return;

      // On mobile (the swipe-strip layout), scroll the gallery so the
      // initially-active pane is centred — otherwise the strip starts
      // at scrollLeft 0 which shows the leftmost (left view) pane.
      if (window.matchMedia('(max-width: 899px)').matches) {
        var heroEl = document.querySelector('[data-fb-gallery]');
        var activePane = document.querySelector('[data-fb-hero-pane].is-active');
        if (heroEl && activePane) {
          heroEl.scrollLeft = activePane.offsetLeft;
        }
      }

      function activateView(viewId) {
        // Hero panes (desktop: display toggle; mobile: just track which is "centred")
        var panes = document.querySelectorAll('[data-fb-hero-pane]');
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-fb-hero-pane') === viewId);
        });
        // Thumbs
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-fb-thumb-view') === viewId);
        });
        // Scroll the hero container to centre on the active pane (mobile swipe strip).
        // No-op on desktop where the container isn't horizontally scrollable.
        var pane = document.querySelector('[data-fb-hero-pane="' + viewId + '"]');
        if (pane && pane.scrollIntoView) {
          pane.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
        renderAll();
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var viewId = thumb.getAttribute('data-fb-thumb-view');
          if (!viewId) return;

          // Video thumb: lazy-attach the source to the corresponding
          // pane's <video> element and start playback. The Liquid
          // markup leaves the <video> with no src + preload="none" so
          // we don't pay the bandwidth cost on every page load (most
          // customers never play it). The thumb carries data-video-src
          // and data-video-type which we wire across on first click.
          // Setting src twice is a no-op (we compare against the
          // existing src attribute first).
          if (viewId === 'video') {
            var videoEl = document.querySelector('[data-fb-hero-pane="video"] [data-sp-hero-video]');
            if (videoEl) {
              var vSrc  = thumb.getAttribute('data-video-src');
              var vType = thumb.getAttribute('data-video-type') || 'video/mp4';
              if (vSrc && videoEl.getAttribute('src') !== vSrc) {
                videoEl.setAttribute('src',  vSrc);
                videoEl.setAttribute('type', vType);
                videoEl.load();
              }
              // play() returns a Promise that may reject when autoplay
              // is blocked by the browser. The video element has the
              // `controls` attribute so the customer can press play
              // manually; we still try .play() so the click feels
              // responsive when autoplay is allowed.
              var playPromise = videoEl.play();
              if (playPromise && playPromise.catch) {
                playPromise.catch(function () { /* autoplay blocked — controls still work */ });
              }
            }
          }

          activateView(viewId);
        });
      });

      // ----- Clone thumbnails (full-width-template bottom area) -----
      // Each clone mirrors a gallery thumb. Click → scroll the gallery
      // into view at the top of the page, then activate the same view
      // so the customer immediately sees their design from that angle.
      // Active state is mirrored from the gallery thumbs so they stay
      // in sync regardless of which set the customer interacts with.
      //
      // IMPORTANT: this snippet's <script> runs synchronously during
      // HTML parsing. The clone thumbs sit in markup that comes AFTER
      // the personaliser snippet renders in the section file (the
      // bottom-atc area is a sibling that follows the snippet), so
      // they don't exist in the DOM yet at this point. Defer the
      // setup to DOMContentLoaded so the section has finished parsing.
      function setupCloneThumbs() {
      var cloneThumbs = document.querySelectorAll('[data-fb-thumb-clone]');
      var cloneContainer = document.querySelector('[data-fb-thumb-clones]');
      if (cloneThumbs.length) {
        var galleryEl = document.querySelector('.sp-gallery') ||
                        document.querySelector('[data-fb-gallery]');

        // Use event delegation on the container — more robust than
        // per-button listeners (catches clicks on any descendant
        // including the layered img/canvas/overlay regardless of
        // pointer-events oddities).
        if (cloneContainer) {
          cloneContainer.addEventListener('click', function (e) {
            var clone = e.target.closest && e.target.closest('[data-fb-thumb-clone]');
            if (!clone) return;
            var viewId = clone.getAttribute('data-fb-thumb-clone-view');
            if (!viewId) return;
            // Scroll page up to the gallery first (smooth), then
            // activate the view. activateView itself will scroll the
            // gallery's hero strip horizontally on mobile.
            if (galleryEl && galleryEl.scrollIntoView) {
              galleryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            activateView(viewId);
          });
        } else {
          // Fallback: per-button listeners (in case container missing)
          cloneThumbs.forEach(function (clone) {
            clone.addEventListener('click', function () {
              var viewId = clone.getAttribute('data-fb-thumb-clone-view');
              if (!viewId) return;
              if (galleryEl && galleryEl.scrollIntoView) {
                galleryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              activateView(viewId);
            });
          });
        }

        // Sync clone active state with gallery thumb active state.
        // Wraps activateView so we update both sets every time it runs.
        var origActivateView = activateView;
        activateView = function (viewId) {
          origActivateView(viewId);
          cloneThumbs.forEach(function (c) {
            c.classList.toggle('is-active', c.getAttribute('data-fb-thumb-clone-view') === viewId);
          });
        };
        // Also reflect the initial active state.
        var initialActive = document.querySelector('[data-fb-thumb-view].is-active');
        if (initialActive) {
          var initId = initialActive.getAttribute('data-fb-thumb-view');
          cloneThumbs.forEach(function (c) {
            c.classList.toggle('is-active', c.getAttribute('data-fb-thumb-clone-view') === initId);
          });
        }
      }
      } // end setupCloneThumbs
      // Run setupCloneThumbs after the rest of the section has parsed
      // (the clone thumbs are below this snippet in the section file).
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupCloneThumbs);
      } else {
        setupCloneThumbs();
      }

      // Sync mobile-swipe state. On scroll, find the centred pane and
      // promote its thumb to active. (CSS scroll-snap handles the snap;
      // we just track which pane is currently centred.)
      var hero = document.querySelector('[data-fb-gallery]');
      if (hero) {
        var scrollTimer = null;
        hero.addEventListener('scroll', function () {
          if (scrollTimer) clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var heroRect = hero.getBoundingClientRect();
            var heroCenterX = heroRect.left + heroRect.width / 2;
            var panes = hero.querySelectorAll('[data-fb-hero-pane]');
            var closestId = null, closestDist = Infinity;
            panes.forEach(function (p) {
              var r = p.getBoundingClientRect();
              var dist = Math.abs((r.left + r.width / 2) - heroCenterX);
              if (dist < closestDist) {
                closestDist = dist;
                closestId = p.getAttribute('data-fb-hero-pane');
              }
            });
            if (closestId) {
              thumbs.forEach(function (t) {
                t.classList.toggle('is-active', t.getAttribute('data-fb-thumb-view') === closestId);
              });
            }
          }, 100);
        }, { passive: true });
      }
    })();
  })();
